(function () {
  if (window.ParityConvermaxMakeOrder) return;

  var priorityMakes = [
    ['harley davidson', 'harley davidsion'],
    ['indian', 'indian motorcycle'],
    ['polaris', 'polaris industries'],
  ];
  var vehicleFields = ['Year', 'Make', 'Model', 'Submodel'];
  var sortedSignatures = new WeakMap();
  var scheduled = false;
  var garageNavigationScheduled = false;
  var filterChromeScheduled = false;
  var pendingGarageDialogSelection = null;
  var filterCueThreshold = 300;
  var filterCueDuration = 4600;
  var filterAccordionDuration = 320;
  var filterAccordionEasing = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var facetAccordionTimers = new WeakMap();
  var removingGroupedActiveFilterChips = false;
  var activeFilterChipPlacements = new WeakMap();
  var lastActiveFilterChipParts = [];
  var filterCueSeenStorageKey = 'parityCmFilterCueSeenDate';
  var filterCueDailyPending = false;
  var filterCueStates = new WeakMap();
  var filterCueFallbackColors = ['#e54200', '#287d3c', '#276ef1', '#d98c00', '#7b4ad8', '#008a7a', '#dd0330', '#12343b'];
  var productRootSelector = '#cm_results, #cm-collection-page, #cm-collection-list, #cm-brand-list, #cm_SearchPage';
  var filterRootSelector = [
    '.parity-category-tree',
    productRootSelector,
    '#cm_FacetDialog',
    '.FacetDialog',
  ].join(', ');
  var garageShopPartsUrl = '/collections/motorcycle-parts';
  var searchSecondaryCategoryLimit = 4;
  var searchCategoryDefinitions = [
    {
      title: 'Air & Fuel',
      href: '/collections/motorcycle-air-fuel',
      keywords: ['air filter', 'air filters', 'fuel air', 'fuel/air', 'fuel system', 'fuel systems', 'carburetor', 'carburetors', 'intake'],
      productTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Audio & Speakers',
      href: '/collections/motorcycle-audio',
      keywords: ['audio', 'speaker', 'speakers', 'stereo', 'amp', 'amplifier'],
      productTypes: ['Audio & Speakers', 'Audio'],
    },
    {
      title: 'Batteries & Electrical',
      href: '/collections/motorcycle-batteries-electrical',
      keywords: ['battery', 'batteries', 'electrical', 'stator', 'regulator', 'starter'],
      productTypes: ['Batteries & Electrical', 'Electrical'],
    },
    {
      title: 'Bike Protection',
      href: '/collections/motorcycle-bike-protection',
      keywords: ['bike protection', 'protection', 'guard', 'guards', 'crash bar', 'crash bars'],
      productTypes: ['Bike Protection'],
    },
    {
      title: 'Body, Fairing & Fender',
      href: '/collections/motorcycle-body-parts',
      keywords: ['body', 'fairing', 'fairings', 'fender', 'fenders'],
      productTypes: ['Body, Fairing & Fender', 'Body Parts'],
    },
    {
      title: 'Brakes',
      href: '/collections/motorcycle-brakes',
      keywords: ['brake', 'brakes', 'rotor', 'pad', 'pads', 'caliper'],
      productTypes: ['Brakes'],
    },
    {
      title: 'Dash & Gauges',
      href: '/collections/motorcycle-dash-gauges',
      keywords: ['dash', 'gauge', 'gauges', 'speedometer', 'tachometer'],
      productTypes: ['Dash & Gauges', 'Dashes & Gauges'],
    },
    {
      title: 'Drive & Transmission',
      href: '/collections/motorcycle-drive-transmission',
      keywords: ['drive', 'transmission', 'clutch', 'chain', 'belt', 'sprocket'],
      productTypes: ['Drive & Transmission', 'Transmission & Driveline'],
    },
    {
      title: 'Engine',
      href: '/collections/motorcycle-engine',
      keywords: ['engine', 'motor', 'piston', 'camshaft', 'valve', 'gasket', 'gaskets', 'seal', 'seals'],
      productTypes: ['Engine'],
      relatedProductTypes: ['Gaskets & Seals'],
    },
    {
      title: 'Exhaust',
      href: '/collections/motorcycle-exhaust',
      keywords: ['exhaust', 'muffler', 'slip on', 'slip-on', 'header', 'full system'],
      productTypes: ['Exhaust Systems'],
    },
    {
      title: 'Filters',
      href: '/collections/motorcycle-air-fuel-oil-filters',
      keywords: ['air filter', 'air filters', 'oil filter', 'oil filters', 'fuel filter', 'fuel filters', 'filter', 'filters'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems', 'Tanks & Oil Filters'],
    },
    {
      title: 'Foot Controls',
      href: '/collections/motorcycle-foot-controls',
      keywords: ['foot control', 'foot controls', 'footpeg', 'footpegs', 'floorboard', 'floorboards'],
      productTypes: ['Foot Controls'],
    },
    {
      title: 'Gas & Oil Tanks',
      href: '/collections/motorcycle-gas-oil-tanks',
      keywords: ['tank', 'tanks', 'oil filter', 'oil filters', 'gas tank', 'fuel tank'],
      productTypes: ['Tanks & Oil Filters'],
    },
    {
      title: 'Handlebars & Controls',
      href: '/collections/motorcycle-hand-controls-handlebars',
      keywords: ['handlebar', 'handlebars', 'control', 'controls', 'lever', 'grip', 'grips'],
      productTypes: ['Handlebars & Controls'],
    },
    {
      title: 'Lighting',
      href: '/collections/motorcycle-lighting',
      keywords: ['light', 'lights', 'lighting', 'headlight', 'taillight', 'turn signal'],
      productTypes: ['Lighting'],
    },
    {
      title: 'Mirrors',
      href: '/collections/motorcycle-mirrors',
      keywords: ['mirror', 'mirrors'],
      productTypes: ['Mirrors & Accessories'],
    },
    {
      title: 'Seats & Sissy Bars',
      href: '/collections/motorcycle-seating',
      keywords: ['seat', 'seats', 'sissy bar', 'backrest'],
      productTypes: ['Seats & Sissy Bars'],
    },
    {
      title: 'Suspension & Frame',
      href: '/collections/motorcycle-suspension',
      keywords: ['suspension', 'shock', 'shocks', 'fork', 'frame'],
      productTypes: ['Frames & Suspension'],
    },
    {
      title: 'Wheel & Axle',
      href: '/collections/motorcycle-wheel-axle',
      keywords: ['wheel', 'wheels', 'axle', 'axles'],
      productTypes: ['Wheel & Axle', 'Wheels & Axles'],
    },
    {
      title: 'Windshields & Windscreens',
      href: '/collections/motorcycle-windshields-windscreens',
      keywords: ['windshield', 'windshields', 'windscreen', 'windscreens'],
      productTypes: ['Windshields & Windscreens', 'Windshields & Fairings'],
    },
    {
      title: 'Air Filters',
      href: '/collections/motorcycle-air-filters',
      tier: 'secondary',
      keywords: ['air filter', 'air filters'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Air Cleaners',
      href: '/collections/motorcycle-air-cleaners',
      tier: 'secondary',
      keywords: ['air cleaner', 'air cleaners', 'air filter', 'air filters', 'intake'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Carburetors',
      href: '/collections/motorcycle-carburetors',
      tier: 'secondary',
      keywords: ['carburetor', 'carburetors', 'carb'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Fuel Management',
      href: '/collections/motorcycle-fuel-management',
      tier: 'secondary',
      keywords: ['fuel management', 'fuel tuner', 'fuel tuners', 'efi tuner', 'efi tuners'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Intake Manifolds',
      href: '/collections/motorcycle-intake-manifolds',
      tier: 'secondary',
      keywords: ['intake manifold', 'intake manifolds', 'intake'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Reed Valves',
      href: '/collections/motorcycle-reed-valves',
      tier: 'secondary',
      keywords: ['reed valve', 'reed valves', 'reeds'],
      productTypes: [],
      relatedProductTypes: ['Fuel/Air Systems'],
    },
    {
      title: 'Oil Filters',
      href: '/collections/motorcycle-oil-filters',
      tier: 'secondary',
      keywords: ['oil filter', 'oil filters'],
      productTypes: [],
      relatedProductTypes: ['Tanks & Oil Filters'],
    },
    {
      title: 'Seat Covers',
      href: '/collections/motorcycle-seat-covers',
      tier: 'secondary',
      keywords: ['seat cover', 'seat covers', 'seat', 'seats'],
      productTypes: [],
      relatedProductTypes: ['Seats & Sissy Bars'],
    },
    {
      title: 'Seat Pads',
      href: '/collections/motorcycle-seat-pads',
      tier: 'secondary',
      keywords: ['seat pad', 'seat pads', 'seat', 'seats'],
      productTypes: [],
      relatedProductTypes: ['Seats & Sissy Bars'],
    },
    {
      title: 'Sissy Bars',
      href: '/collections/motorcycle-sissy-bars',
      tier: 'secondary',
      keywords: ['sissy bar', 'sissy bars', 'sissy'],
      productTypes: [],
      relatedProductTypes: ['Seats & Sissy Bars'],
    },
    {
      title: 'Seat Accessories',
      href: '/collections/motorcycle-seating-accessories',
      tier: 'secondary',
      keywords: ['seat accessory', 'seat accessories', 'seat', 'seats'],
      productTypes: [],
      relatedProductTypes: ['Seats & Sissy Bars'],
    },
    {
      title: 'Seat Hardware',
      href: '/collections/motorcycle-seat-hardware',
      tier: 'secondary',
      keywords: ['seat hardware', 'seat mount', 'seat mounts', 'seat', 'seats'],
      productTypes: [],
      relatedProductTypes: ['Seats & Sissy Bars'],
    },
  ];
  var productTypeV3FacetField = 'custom_product_type_v3_filter';
  var productTypeV3FacetVersion = 'token-2026-07-22';
  var productTypeV3SuppressedLabels = [
    '1 1 4 inch risers',
    '1 inch handlebars',
  ];
  var productTypeV3ParentCategories = [
    ['motorcycle-air-fuel', 'Air & Fuel', 327],
    ['motorcycle-audio', 'Audio & Speakers', 333],
    ['motorcycle-batteries-electrical', 'Batteries & Electrical', 334],
    ['motorcycle-body-parts', 'Body, Fairing & Fender', 379],
    ['motorcycle-brakes', 'Brakes', 390],
    ['motorcycle-dash-gauges', 'Dash & Gauges', 397],
    ['motorcycle-drive-transmission', 'Drive & Transmission', 400],
    ['motorcycle-engine', 'Engine', 414],
    ['motorcycle-exhaust', 'Exhaust', 426],
    ['motorcycle-air-fuel-oil-filters', 'Filter', 436],
    ['motorcycle-foot-controls', 'Foot Controls', 439],
    ['motorcycle-gas-oil-tanks', 'Gas & Oil Tanks', 449],
    ['motorcycle-hand-controls-handlebars', 'Handlebars & Controls', 450],
    ['motorcycle-lighting', 'Lighting', 490],
    ['motorcycle-mirrors', 'Mirrors & Accessories', 499],
    ['motorcycle-seating', 'Seats & Sissy Bars', 500],
    ['motorcycle-suspension', 'Suspension & Frame', 506],
    ['motorcycle-bike-protection', 'Vehicle Protection', 507],
    ['motorcycle-wheel-axle', 'Wheel & Axle', 508],
    ['motorcycle-windshields-windscreens', 'Windshields & Windscreens', 511],
    ['motorcycle-helmets', 'Helmets', 520],
  ];
  var productTypeV3ParentCategoryIndexByHandle = {
    'motorcycle-air-cleaners': 0,
    'motorcycle-air-filters': 0,
    'motorcycle-air-fuel': 0,
    'motorcycle-carburetors': 0,
    'motorcycle-fuel-management': 0,
    'motorcycle-intake-manifolds': 0,
    'motorcycle-reed-valves': 0,
    'motorcycle-audio': 1,
    'agm-motorcycle-batteries': 2,
    'factory-activated-motorcycle-batteries': 2,
    'gyz16h-battery-equivalents': 2,
    'lead-acid-motorcycle-batteries': 2,
    'lithium-ion-motorcycle-batteries': 2,
    'motorcycle-batteries': 2,
    'motorcycle-batteries-electrical': 2,
    'motorcycle-cables-wires': 2,
    'motorcycle-fuse-blocks': 2,
    'motorcycle-horn-covers': 2,
    'motorcycle-horns': 2,
    'motorcycle-ignition': 2,
    'motorcycle-ignition-kits-modules': 2,
    'motorcycle-regulators': 2,
    'motorcycle-spark-plug-wires': 2,
    'motorcycle-spark-plugs': 2,
    'motorcycle-starters': 2,
    'motorcycle-stators': 2,
    'motorcycle-wiring-harnesses': 2,
    'vintage-harley-davidson-motorcycle-batteries': 2,
    'ytx20hl-battery-equivalents': 2,
    'ytx20l-battery-equivalents': 2,
    'ytx9bs-battery-equivalents': 2,
    'ytz10s-battery-equivalents': 2,
    'ytz14s-battery-equivalents': 2,
    'ytz7s-battery-equivalents': 2,
    'motorcycle-body-parts': 3,
    'motorcycle-bodywork': 3,
    'motorcycle-fairings': 3,
    'motorcycle-fender-eliminator-kits': 3,
    'motorcycle-fenders-extenders': 3,
    'motorcycle-graphics-kits': 3,
    'motorcycle-number-plates': 3,
    'motorcycle-plastics-kits': 3,
    'motorcycle-rear-huggers': 3,
    'motorcycle-signal-block-offs': 3,
    'motorcycle-undertails': 3,
    'motorcycle-brake-calipers': 4,
    'motorcycle-brake-hardware-covers': 4,
    'motorcycle-brake-lines': 4,
    'motorcycle-brake-master-cylinders': 4,
    'motorcycle-brake-pads': 4,
    'motorcycle-brake-rotors': 4,
    'motorcycle-brakes': 4,
    'motorcycle-dash': 5,
    'motorcycle-dash-gauges': 5,
    'motorcycle-gauges': 5,
    'derby-covers-harley': 6,
    'motorcycle-axle-blocks': 6,
    'motorcycle-belt-guards': 6,
    'motorcycle-belt-pulleys': 6,
    'motorcycle-chains': 6,
    'motorcycle-clutch': 6,
    'motorcycle-drive-belts': 6,
    'motorcycle-drive-transmission': 6,
    'motorcycle-inspection-covers': 6,
    'motorcycle-kick-starts': 6,
    'motorcycle-primary-covers': 6,
    'motorcycle-quick-shifters': 6,
    'motorcycle-sprockets': 6,
    'motorcycle-transmission-covers': 6,
    'motorcycle-big-bore-kits': 7,
    'motorcycle-blockoff-plates': 7,
    'motorcycle-cam-covers': 7,
    'motorcycle-camshafts': 7,
    'motorcycle-clutch-covers': 7,
    'motorcycle-engine': 7,
    'motorcycle-engine-accents': 7,
    'motorcycle-engine-hardware': 7,
    'motorcycle-engine-rebuild-kits': 7,
    'motorcycle-gaskets': 7,
    'motorcycle-water-pumps': 7,
    'radiators': 7,
    'motorcycle-exhaust': 8,
    'motorcycle-exhaust-accessories': 8,
    'motorcycle-exhaust-baffles-inserts': 8,
    'motorcycle-exhaust-gaskets': 8,
    'motorcycle-exhaust-heat-shields': 8,
    'motorcycle-exhaust-tape': 8,
    'motorcycle-exhaust-tips-caps': 8,
    'motorcycle-full-system-exhaust': 8,
    'motorcycle-headers': 8,
    'motorcycle-slip-on-exhaust': 8,
    'motorcycle-air-fuel-oil-filters': 9,
    'motorcycle-oil-filters': 9,
    'motorcycle-brake-pedals': 10,
    'motorcycle-floorboard-relocation-kits': 10,
    'motorcycle-floorboards': 10,
    'motorcycle-foot-controls': 10,
    'motorcycle-foot-pegs': 10,
    'motorcycle-mid-forward-controls': 10,
    'motorcycle-rear-sets': 10,
    'motorcycle-shifter-levers': 10,
    'motorcycle-shifter-pegs': 10,
    'motorcycle-shifters': 10,
    'motorcycle-gas-oil-tanks': 11,
    '12-inch-handlebars-motorcycle': 12,
    'blue-motorcycle-grips': 12,
    'brown-motorcycle-grips': 12,
    'gold-motorcycle-grips': 12,
    'green-motorcycle-grips': 12,
    'motorcycle-1-1-4-inch-risers': 12,
    'motorcycle-1-inch-handlebars': 12,
    'motorcycle-14-inch-height-handlebars': 12,
    'motorcycle-7-8-inch-handlebars': 12,
    'motorcycle-bagger-handlebars': 12,
    'motorcycle-bar-ends': 12,
    'motorcycle-bottle-holders': 12,
    'motorcycle-cables-lines': 12,
    'motorcycle-clip-ons': 12,
    'motorcycle-clutch-master-cylinders': 12,
    'motorcycle-cup-holders': 12,
    'motorcycle-drag-handlebars': 12,
    'motorcycle-drink-holders': 12,
    'motorcycle-grips': 12,
    'motorcycle-hand-controls-handlebars': 12,
    'motorcycle-hand-guards': 12,
    'motorcycle-handlebar-pads': 12,
    'motorcycle-handlebars': 12,
    'motorcycle-heated-grips': 12,
    'motorcycle-idle-cables': 12,
    'motorcycle-lever-guards': 12,
    'motorcycle-levers': 12,
    'motorcycle-passenger-handles': 12,
    'motorcycle-risers': 12,
    'motorcycle-steering-dampers': 12,
    'motorcycle-t-bar-handlebars': 12,
    'motorcycle-throttle': 12,
    'motorcycle-throttle-cables': 12,
    'motorcycle-throttle-locks': 12,
    'motorcycle-z-bar-handlebars': 12,
    'orange-motorcycle-grips': 12,
    'pink-motorcycle-grips': 12,
    'purple-motorcycle-grips': 12,
    'red-motorcycle-grips': 12,
    'white-motorcycle-grips': 12,
    'motorcycle-auxiliary-lights': 13,
    'motorcycle-bulbs': 13,
    'motorcycle-headlights': 13,
    'motorcycle-license-plate-mounts': 13,
    'motorcycle-lighting': 13,
    'motorcycle-lighting-accessories': 13,
    'motorcycle-lighting-kits': 13,
    'motorcycle-tail-brake-lights': 13,
    'motorcycle-turn-signals': 13,
    'motorcycle-mirrors': 14,
    'motorcycle-backrests': 15,
    'motorcycle-gripper-seat-covers': 15,
    'motorcycle-heated-seats': 15,
    'motorcycle-passenger-backrests': 15,
    'motorcycle-performance-seats': 15,
    'motorcycle-pillion-passenger-pads': 15,
    'motorcycle-replacement-seat-covers': 15,
    'motorcycle-seat-brackets-frames': 15,
    'motorcycle-seat-cover-foam-kits': 15,
    'motorcycle-seat-covers': 15,
    'motorcycle-seat-cushions': 15,
    'motorcycle-seat-foam': 15,
    'motorcycle-seat-hardware': 15,
    'motorcycle-seat-heaters': 15,
    'motorcycle-seat-insulation-kits': 15,
    'motorcycle-seat-knobs': 15,
    'motorcycle-seat-material-swatches': 15,
    'motorcycle-seat-mounting-hardware': 15,
    'motorcycle-seat-pads': 15,
    'motorcycle-seat-springs': 15,
    'motorcycle-seating': 15,
    'motorcycle-seating-accessories': 15,
    'motorcycle-seats': 15,
    'motorcycle-sissy-bar-bags': 15,
    'motorcycle-sissy-bar-hardware': 15,
    'motorcycle-sissy-bar-pads': 15,
    'motorcycle-sissy-bar-side-plates': 15,
    'motorcycle-sissy-bars': 15,
    'motorcycle-solo-seats': 15,
    'motorcycle-step-up-seats': 15,
    'motorcycle-touring-seats': 15,
    'motorcycle-two-up-seats': 15,
    'motorcycle-shock-absorbers': 16,
    'motorcycle-suspension': 16,
    'motorcycle-axle-sliders': 17,
    'motorcycle-bike-protection': 17,
    'motorcycle-brake-guards': 17,
    'motorcycle-chain-guards': 17,
    'motorcycle-crash-bar-bags': 17,
    'motorcycle-crash-bars': 17,
    'motorcycle-engine-covers': 17,
    'motorcycle-engine-guards': 17,
    'motorcycle-fork-guards': 17,
    'motorcycle-frame-guards': 17,
    'motorcycle-frame-sliders': 17,
    'motorcycle-header-guards': 17,
    'motorcycle-headlight-guards': 17,
    'motorcycle-radiator-oil-cooler-guards': 17,
    'motorcycle-side-stand-feet': 17,
    'motorcycle-skid-plates': 17,
    'motorcycle-swingarm-spools': 17,
    'motorcycle-tank-protectors': 17,
    'motorcycle-wheel-axle': 18,
    'motorcycle-wheel-weights': 18,
    'wheel-bearings': 18,
    'motorcycle-windscreen-accessories': 19,
    'motorcycle-windshields-windscreens': 19,
    'motorcycle-helmets': 20,
    'helmets': 20,
    'full-face-motorcycle-helmets': 20,
    'full-face': 20,
    'modular-motorcycle-helmets': 20,
    'modular': 20,
    'dual-sport-helmets': 20,
    'dual-sport': 20,
    'dirt-bike-helmets': 20,
    'dirt': 20,
    'open-face-helmets': 20,
    'open-face': 20,
    'motorcycle-half-helmets': 20,
    'half': 20,
    'face-shields-visors': 20,
    'ece-motorcycle-helmets': 20,
    'ece-certified-helmets': 20,
    'ece-22-05-helmets': 20,
    'ece-22-06-helmets': 20,
    'bluetooth-helmets': 20,
    'bluetooth-integrated-helmets': 20,
  };
  var productTypeV3HelmetOptionAliasesByHandle = {
    'full-face-motorcycle-helmets': ['full-face', 'Full Face', '001'],
    'full-face': ['full-face', 'Full Face', '001'],
    'modular-motorcycle-helmets': ['modular', 'Modular', '002'],
    'modular': ['modular', 'Modular', '002'],
    'dual-sport-helmets': ['dual-sport', 'Dual Sport', '003'],
    'dual-sport': ['dual-sport', 'Dual Sport', '003'],
    'dirt-bike-helmets': ['dirt', 'Dirt', '004'],
    'dirt': ['dirt', 'Dirt', '004'],
    'open-face-helmets': ['open-face', 'Open Face', '005'],
    'open-face': ['open-face', 'Open Face', '005'],
    'motorcycle-half-helmets': ['half', 'Half', '006'],
    'half': ['half', 'Half', '006'],
    'face-shields-visors': ['face-shields', 'Face Shields', '007'],
    'ece-motorcycle-helmets': ['ece-certified', 'ECE Certified', '008'],
    'ece-certified-helmets': ['ece-certified', 'ECE Certified', '008'],
    'ece-22-05-helmets': ['ece-certified', 'ECE Certified', '008'],
    'ece-22-06-helmets': ['ece-certified', 'ECE Certified', '008'],
    'bluetooth-helmets': ['bluetooth-communications', 'Bluetooth Communications', '009'],
    'bluetooth-integrated-helmets': ['bluetooth-communications', 'Bluetooth Communications', '009'],
  };

  function encodeVehicleSegment(value) {
    return encodeURIComponent(String(value || '').trim());
  }

  function clean(value) {
    return String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/\u00a0/g, ' ')
      .replace(/[^a-z0-9]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function decodeUserSurfaceText(value, options) {
    var settings = options || {};
    var text = String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/&#38;/gi, '&')
      .replace(/&#x26;/gi, '&')
      .replace(/\u00a0/g, ' ');
    var decodePlusAsSpace = Boolean(settings.decodePlusAsSpace);
    var preserveWhitespace = Boolean(settings.preserveWhitespace);

    for (var index = 0; index < 3; index += 1) {
      var candidate = decodePlusAsSpace ? text.replace(/\+/g, '%20') : text;
      candidate = candidate.replace(/%(?![0-9a-f]{2})/gi, '%25');

      try {
        var decoded = decodeURIComponent(candidate);
        if (decoded === text) break;
        text = decoded;
      } catch (_error) {
        break;
      }
    }

    text = text
      .replace(/&amp;/gi, '&')
      .replace(/&#38;/gi, '&')
      .replace(/&#x26;/gi, '&')
      .replace(/\u00a0/g, ' ');

    return preserveWhitespace ? text : text.replace(/\s+/g, ' ').trim();
  }

  function optionText(option) {
    return (option.textContent || option.label || '').replace(/\s+/g, ' ').trim();
  }

  function priorityRank(option) {
    var normalized = clean(optionText(option));

    for (var index = 0; index < priorityMakes.length; index += 1) {
      if (priorityMakes[index].some(function (make) {
        return normalized === make || normalized.indexOf(make + ' ') === 0;
      })) {
        return index;
      }
    }

    return priorityMakes.length;
  }

  function isPlaceholder(option) {
    if (!option) return false;
    var text = clean(optionText(option));
    return option.value === '' || text === '' || text === 'make' || text === 'select make' || text === 'choose make';
  }

  function optionSignature(select) {
    return Array.from(select.options)
      .map(function (option) {
        return [
          option.value,
          optionText(option),
          option.disabled ? '1' : '0',
          option.hidden ? '1' : '0',
        ].join('\u0000');
      })
      .join('\u0001');
  }

  function isMakeSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.matches('[data-parity-fitment-proxy="make"]')) return true;

    var labels = [
      select.getAttribute('aria-label'),
      select.getAttribute('name'),
      select.getAttribute('id'),
      select.getAttribute('data-placeholder'),
      select.className,
    ].join(' ');
    var hasMakeLabel = /\bmake\b/i.test(labels)
      || Array.from(select.options).some(function (option) {
        return clean(optionText(option)) === 'make';
      });

    if (!hasMakeLabel) return false;

    return Boolean(select.closest([
      '.cm_vehicle-widget',
      '.cm_vehicle-widget__verify-fitment',
      '.cm_ymm',
      '[class*="cm_"]',
      '[id^="cm-"]',
      '#cm-ymm',
      '#cm-garage',
      '#cm-mobile-garage',
      '[data-parity-fitment-selector]',
    ].join(',')));
  }

  function compareOptions(left, right) {
    var leftRank = priorityRank(left.option);
    var rightRank = priorityRank(right.option);

    if (leftRank !== rightRank) return leftRank - rightRank;

    var textCompare = optionText(left.option).localeCompare(optionText(right.option), undefined, {
      numeric: true,
      sensitivity: 'base',
    });

    return textCompare || left.index - right.index;
  }

  function sortSelect(select) {
    if (!isMakeSelect(select) || select.options.length < 2) return false;

    var currentSignature = optionSignature(select);
    if (sortedSignatures.get(select) === currentSignature) return false;

    var options = Array.from(select.options);
    var placeholders = [];
    var realOptions = [];

    options.forEach(function (option, index) {
      if (isPlaceholder(option) && realOptions.length === 0) {
        placeholders.push({ option: option, index: index });
      } else {
        realOptions.push({ option: option, index: index });
      }
    });

    var sorted = placeholders.concat(realOptions.sort(compareOptions));
    var unchanged = sorted.every(function (entry, index) {
      return entry.option === options[index];
    });

    if (unchanged) {
      sortedSignatures.set(select, currentSignature);
      return false;
    }

    var selectedValue = select.value;
    var selectedOptions = options.filter(function (option) { return option.selected; });
    var fragment = document.createDocumentFragment();

    sorted.forEach(function (entry) {
      fragment.appendChild(entry.option);
    });

    select.appendChild(fragment);

    selectedOptions.forEach(function (option) {
      option.selected = true;
    });

    if (select.value !== selectedValue && options.some(function (option) { return option.value === selectedValue; })) {
      select.value = selectedValue;
    }

    sortedSignatures.set(select, optionSignature(select));
    return true;
  }

  function collectSelects(root) {
    var selects = [];

    if (root && root.nodeType === 1 && root.matches && root.matches('select')) {
      selects.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('select').forEach(function (select) {
        selects.push(select);
      });
    }

    return selects;
  }

  function sortAll(root) {
    collectSelects(root || document).forEach(sortSelect);
  }

  function currentCollectionHandleFromPath() {
    var match = String(window.location?.pathname || '').match(/^\/collections\/([^/?#]+)\/?$/i);
    if (!match) return '';

    try {
      return decodeURIComponent(match[1]);
    } catch (_error) {
      return match[1];
    }
  }

  function suppressCategoryFacetOnCurrentCollection() {
    return currentCollectionHandleFromPath() === 'motorcycle-parts';
  }

  function removeCollectionCategoryFacetSources() {
    document.querySelectorAll('[data-parity-category-filter-source], [data-parity-category-filter-clone]').forEach(function (facet) {
      facet.remove();
    });
  }

  function getCategoryFacetSource() {
    if (suppressCategoryFacetOnCurrentCollection()) return null;

    return Array.from(document.querySelectorAll('[data-parity-category-filter-source], [data-parity-search-category-filter-source]')).find(function (node) {
      return !node.closest('#cm_FacetDialog');
    }) || null;
  }

  function prefersReducedAccordionMotion() {
    try {
      return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    } catch (_error) {
      return false;
    }
  }

  function clearFacetBodyAccordion(body) {
    if (!body) return;

    var timer = facetAccordionTimers.get(body);
    if (timer) window.clearTimeout(timer);
    facetAccordionTimers.delete(body);
    delete body.dataset.parityCmAccordionAnimating;
    delete body.dataset.parityCmAccordionToken;
  }

  function resetFacetBodyAnimationStyles(body) {
    removeInlineStyleIfPresent(body, 'transition');
    removeInlineStyleIfPresent(body, 'opacity');
    removeInlineStyleIfPresent(body, 'transform');
    removeInlineStyleIfPresent(body, 'willChange');
  }

  function setFacetBodyExpanded(body, expanded, animate) {
    if (!body) return;

    clearFacetBodyAccordion(body);

    if (!animate || prefersReducedAccordionMotion()) {
      resetFacetBodyAnimationStyles(body);
      setHiddenIfChanged(body, !expanded);
      body.classList.toggle('collapsed', !expanded);

      if (expanded) {
        removeInlineStyleIfPresent(body, 'height');
        removeInlineStyleIfPresent(body, 'overflow');
        removeInlineStyleIfPresent(body, 'position');
      } else {
        setInlineStyleIfChanged(body, 'position', 'relative');
        setInlineStyleIfChanged(body, 'height', '0px');
        setInlineStyleIfChanged(body, 'overflow', 'hidden');
      }
      return;
    }

    var token = String(Date.now()) + Math.random().toString(16).slice(2);
    var finishDelay = filterAccordionDuration + 80;
    var finish = function () {
      if (body.dataset.parityCmAccordionToken !== token) return;

      clearFacetBodyAccordion(body);
      resetFacetBodyAnimationStyles(body);
      setHiddenIfChanged(body, !expanded);
      body.classList.toggle('collapsed', !expanded);

      if (expanded) {
        removeInlineStyleIfPresent(body, 'height');
        removeInlineStyleIfPresent(body, 'overflow');
        removeInlineStyleIfPresent(body, 'position');
      } else {
        setInlineStyleIfChanged(body, 'position', 'relative');
        setInlineStyleIfChanged(body, 'height', '0px');
        setInlineStyleIfChanged(body, 'overflow', 'hidden');
      }
    };

    body.dataset.parityCmAccordionAnimating = 'true';
    body.dataset.parityCmAccordionToken = token;
    body.hidden = false;
    body.classList.remove('collapsed');
    body.style.position = 'relative';
    body.style.overflow = 'hidden';
    body.style.opacity = expanded ? '0' : '1';
    body.style.transform = expanded ? 'translateY(-3px)' : 'translateY(0)';
    body.style.willChange = 'height, opacity, transform';

    var startHeight = expanded ? 0 : Math.max(body.getBoundingClientRect?.().height || 0, body.scrollHeight || 0);
    var endHeight = expanded ? body.scrollHeight || 0 : 0;

    body.style.height = startHeight + 'px';
    body.offsetHeight;

    window.requestAnimationFrame(function () {
      if (body.dataset.parityCmAccordionToken !== token) return;

      body.style.transition = [
        'height ' + filterAccordionDuration + 'ms ' + filterAccordionEasing,
        'opacity 220ms ease',
        'transform ' + filterAccordionDuration + 'ms ' + filterAccordionEasing,
      ].join(', ');
      body.style.height = endHeight + 'px';
      body.style.opacity = expanded ? '1' : '0';
      body.style.transform = expanded ? 'translateY(0)' : 'translateY(-3px)';
    });

    facetAccordionTimers.set(body, window.setTimeout(finish, finishDelay));
  }

  function bindSyntheticFacet(facet, config) {
    if (!facet || !config) return;
    if (facet.dataset[config.boundDataset] === 'true') return;
    facet.dataset[config.boundDataset] = 'true';

    var handleToggle = function (event) {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target?.closest?.('.parity-cm-category-facet__shop-all')) return;

      var toggle = event.target?.closest?.(config.toggleSelector);
      if (!toggle || !facet.contains(toggle)) return;

      var body = facet.querySelector(config.bodySelector);
      if (!body) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      setFacetBodyExpanded(body, expanded, true);
      facet.classList.toggle('parity-cm-facet-expanded', expanded);
      facet.classList.toggle('parity-cm-facet-collapsed', !expanded);
    };

    facet.addEventListener('click', handleToggle);
    facet.addEventListener('keydown', handleToggle);
  }

  function searchCategoryQueryText() {
    var params = new URLSearchParams(window.location.search || '');
    return [
      params.get('query'),
      params.get('q'),
      params.get('search'),
      window.location.pathname || '',
    ].filter(Boolean).join(' ');
  }

  function textMatchesCategoryKeywords(text, category) {
    var normalizedText = clean(text);
    if (!normalizedText) return false;

    if (clean(category.title) && normalizedText.indexOf(clean(category.title)) !== -1) return true;

    return (category.keywords || []).some(function (keyword) {
      var normalizedKeyword = clean(keyword);
      return normalizedKeyword && normalizedText.indexOf(normalizedKeyword) !== -1;
    });
  }

  function productTypeMatchesCategory(text, category) {
    var normalizedText = clean(text);
    if (!normalizedText) return false;

    return (category.productTypes || []).concat(category.relatedProductTypes || []).some(function (productType) {
      return clean(productType) === normalizedText;
    });
  }

  function searchProductTypeFacetTexts(root) {
    var values = [];

    (root || document).querySelectorAll?.([
      '.cm_field-custom_product_type_v2 .facetentrykey',
      '.cm_field-custom_product_type .facetentrykey',
      '[data-field="custom_product_type_v2"] .facetentrykey',
      '[data-cm-field="custom_product_type_v2"] .facetentrykey',
    ].join(',')).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) values.push(text);
    });

    return values;
  }

  function searchCategoryCandidates(root) {
    var primary = searchCategoryDefinitions.filter(function (category) {
      return category.tier !== 'secondary';
    });
    var secondary = searchCategoryDefinitions.filter(function (category) {
      return category.tier === 'secondary';
    });
    var queryText = searchCategoryQueryText();
    var productTypeTexts = searchProductTypeFacetTexts(root);
    var hasMappedSignal = primary.concat(secondary).some(function (category) {
      return textMatchesCategoryKeywords(queryText, category)
        || productTypeTexts.some(function (text) {
          return productTypeMatchesCategory(text, category);
        });
    });

    if (!hasMappedSignal) return [];

    var querySecondary = secondary.filter(function (category) {
      return textMatchesCategoryKeywords(queryText, category);
    });
    var productTypeSecondary = secondary.filter(function (category) {
      return productTypeTexts.some(function (text) {
        return productTypeMatchesCategory(text, category);
      });
    });
    var selectedSecondary = (querySecondary.length ? querySecondary : productTypeSecondary)
      .slice(0, searchSecondaryCategoryLimit);

    return primary.concat(selectedSecondary);
  }

  function searchCategoryFacetSignature(categories) {
    return (categories || []).map(function (category) {
      return [category.title, category.href].join(':');
    }).join('\u0001');
  }

  function createSearchCategoryFacet() {
    var facet = document.createElement('nav');
    facet.className = 'facetholder parity-cm-category-facet';
    facet.setAttribute('aria-label', 'Categories');
    facet.dataset.paritySearchCategoryFilterSource = 'true';
    return facet;
  }

  function renderSearchCategoryFacet(facet, categories) {
    var signature = searchCategoryFacetSignature(categories);
    if (facet.dataset.parityCategoryFilterSignature === signature) return;

    facet.textContent = '';
    facet.dataset.parityCategoryFilterSignature = signature;
    delete facet.dataset.parityCategoryFilterBound;

    var title = document.createElement('div');
    title.className = 'facettitle parity-cm-category-facet__title';
    title.setAttribute('role', 'button');
    title.tabIndex = 0;
    title.setAttribute('aria-expanded', 'true');
    title.dataset.parityCategoryFilterToggle = 'true';

    var titleMain = document.createElement('span');
    titleMain.className = 'parity-cm-category-facet__title-main';
    titleMain.textContent = 'Categories';
    title.appendChild(titleMain);

    var indicator = document.createElement('span');
    indicator.className = 'parity-cm-category-facet__indicator';
    indicator.setAttribute('aria-hidden', 'true');
    title.appendChild(indicator);
    facet.appendChild(title);

    var body = document.createElement('div');
    body.className = 'facetbody parity-cm-category-facet__body';
    body.dataset.parityCategoryFilterBody = 'true';

    var list = document.createElement('div');
    list.className = 'cmTemplate_simpleFacet parity-cm-category-facet__list';
    list.setAttribute('role', 'list');

    (categories || []).forEach(function (category) {
      var item = document.createElement('div');
      item.className = 'facetdiv parity-cm-category-facet__item';
      item.setAttribute('role', 'listitem');

      var link = document.createElement('a');
      link.className = 'facetentrykey parity-cm-category-facet__link';
      link.href = category.href;
      link.textContent = category.title;
      item.appendChild(link);
      list.appendChild(item);
    });

    body.appendChild(list);
    facet.appendChild(body);
  }

  function bindCategoryFacet(facet) {
    bindSyntheticFacet(facet, {
      boundDataset: 'parityCategoryFilterBound',
      toggleSelector: '[data-parity-category-filter-toggle]',
      bodySelector: '[data-parity-category-filter-body]',
    });
  }

  function safeDecodeURIComponent(value) {
    var text = String(value || '').replace(/\+/g, '%20').replace(/%(?![0-9a-f]{2})/gi, '%25');

    try {
      return decodeURIComponent(text);
    } catch (_error) {
      return String(value || '');
    }
  }

  function normalizeConvermaxFacetValue(value) {
    var text = String(value || '');

    for (var attempt = 0; attempt < 2; attempt += 1) {
      if (text.indexOf('%') === -1 && text.indexOf('+') === -1) break;

      var decoded = safeDecodeURIComponent(text);
      if (decoded === text) break;
      text = decoded;
    }

    return text;
  }

  function isConvermaxFilterField(field) {
    return /^(?:Year|Make|Model|Submodel|collection_ids|custom_[a-z0-9_]+)$/i.test(String(field || ''));
  }

  function convermaxSearchParams(search) {
    return String(search || '').replace(/^\?/, '').split('&').filter(Boolean);
  }

  function convermaxFacetParamValues(search) {
    var values = [];

    try {
      new URLSearchParams(search || '').forEach(function (value, key) {
        if (/^Facet$/i.test(key)) values.push(value);
      });
    } catch (_error) {
      convermaxSearchParams(search).forEach(function (param) {
        if (!isConvermaxFacetParam(param)) return;

        var separator = String(param || '').indexOf('=');
        values.push(separator === -1 ? '' : String(param || '').slice(separator + 1));
      });
    }

    return values;
  }

  function convermaxQueryParamKey(param) {
    var text = String(param || '');
    var separator = text.indexOf('=');
    var key = separator === -1 ? text : text.slice(0, separator);

    return safeDecodeURIComponent(key).replace(/=.*$/, '');
  }

  function isConvermaxFacetParam(param) {
    return /^Facet$/i.test(convermaxQueryParamKey(param));
  }

  function convermaxQueryParamStartsWithFilterPath(param) {
    var firstSegment = convermaxFilterPathSegments(param)[0] || '';
    var field = convermaxFieldFromFilterSegment(firstSegment);

    return isConvermaxFilterField(field);
  }

  function searchUsesConvermaxFacetParam(search) {
    return convermaxSearchParams(search).some(isConvermaxFacetParam);
  }

  function convermaxPreservedQueryParams(search) {
    return convermaxSearchParams(search).filter(function (param) {
      if (isConvermaxFacetParam(param)) return false;
      if (convermaxQueryParamStartsWithFilterPath(param)) return false;

      return !isConvermaxFilterField(convermaxQueryParamKey(param));
    });
  }

  function convermaxFieldFromFilterSegment(segment) {
    return safeDecodeURIComponent(segment).replace(/=.*$/, '');
  }

  function convermaxFilterPathSegments(value) {
    var text = normalizeConvermaxFacetValue(value);
    var separator = text.indexOf('=');

    if (separator !== -1) {
      var key = text.slice(0, separator);
      var paramValue = text.slice(separator + 1);

      if (key.indexOf('/') === -1 && isConvermaxFilterField(key) && paramValue) {
        return [key, paramValue];
      }

      if (key.indexOf('/') !== -1 && !paramValue) {
        text = key;
      }
    }

    return text.split('/').filter(Boolean);
  }

  function convermaxFilterSegmentsFromSearch(search) {
    var segments = [];

    convermaxFacetParamValues(search).forEach(function (value) {
      convermaxFilterPathSegments(value).forEach(function (segment) {
        segments.push(segment);
      });
    });

    convermaxSearchParams(search).forEach(function (param) {
      if (isConvermaxFacetParam(param)) {
        return;
      }

      var paramSegments = convermaxFilterPathSegments(param);
      if (!isConvermaxFilterField(convermaxFieldFromFilterSegment(paramSegments[0] || ''))) return;

      paramSegments.forEach(function (segment) {
        segments.push(segment);
      });
    });

    return segments;
  }

  function convermaxQueryPartsFromSearch(search) {
    var segments = convermaxFilterSegmentsFromSearch(search);
    var parts = [];

    for (var index = 0; index < segments.length; index += 1) {
      var field = convermaxFieldFromFilterSegment(segments[index]);
      if (!isConvermaxFilterField(field) || index + 1 >= segments.length) continue;

      parts.push({
        field: field,
        value: safeDecodeURIComponent(segments[index + 1]).replace(/=$/, ''),
      });
      index += 1;
    }

    return parts;
  }

  function canonicalConvermaxFilterValue(field, value) {
    if (field === productTypeV3FacetField) {
      return productTypeV3TokenForQuery(value) || String(value || '');
    }

    return String(value || '');
  }

  function convermaxCurrentQueryParts(excludeField) {
    return convermaxQueryPartsFromSearch(window.location.search || '').filter(function (part) {
      return !excludeField || part.field !== excludeField;
    });
  }

  function convermaxCurrentFilterValues(field) {
    return convermaxQueryPartsFromSearch(window.location.search || '').filter(function (part) {
      return part.field === field;
    }).map(function (part) {
      return part.value;
    });
  }

  function buildConvermaxFilterQuery(parts) {
    var seen = new Set();

    return (parts || []).map(function (part) {
      var value = canonicalConvermaxFilterValue(part.field, part.value);
      if (!part.field || !value) return '';

      var signature = part.field + '\u0000' + value;
      if (seen.has(signature)) return '';
      seen.add(signature);

      return part.field + '/' + encodeURIComponent(value);
    }).filter(Boolean).join('/');
  }

  function buildConvermaxLocationQuery(parts, options) {
    var filterQuery = buildConvermaxFilterQuery(parts);
    var preservedParams = options?.preserveCurrentQuery
      ? convermaxPreservedQueryParams(window.location.search || '')
      : [];

    if (filterQuery) {
      preservedParams.push(options?.useFacetParam ? 'Facet=' + filterQuery : filterQuery);
    }

    return preservedParams.join('&');
  }

  function normalizeConvermaxLocationQuery() {
    var currentSearch = window.location.search || '';
    var parts = convermaxQueryPartsFromSearch(currentSearch);
    var currentUrl = String(window.location.pathname || '/') + String(window.location.search || '') + String(window.location.hash || '');
    var query = buildConvermaxLocationQuery(parts, {
      preserveCurrentQuery: true,
      useFacetParam: searchUsesConvermaxFacetParam(currentSearch) || convermaxPreservedQueryParams(currentSearch).length > 0,
    });
    var nextUrl = String(window.location.pathname || '/') + (query ? '?' + query : '') + String(window.location.hash || '');

    if (nextUrl === currentUrl) return;

    try {
      window.history?.replaceState?.(window.history.state, document.title, nextUrl);
    } catch (_error) {
      // If history is unavailable, removal handlers still build canonical filter URLs.
    }
  }

  function normalizeProductTypeV3LocationQuery() {
    var parts = convermaxQueryPartsFromSearch(window.location.search || '');
    var hasProductTypeV3 = false;
    var changed = false;
    var normalizedParts = parts.map(function (part) {
      if (part.field !== productTypeV3FacetField) return part;

      hasProductTypeV3 = true;
      var normalizedValue = productTypeV3TokenForQuery(part.value) || part.value;
      if (normalizedValue && normalizedValue !== part.value) changed = true;

      return {
        field: part.field,
        value: normalizedValue,
      };
    });

    if (!hasProductTypeV3 || !changed) return;

    var currentSearch = window.location.search || '';
    var query = buildConvermaxLocationQuery(normalizedParts, {
      preserveCurrentQuery: true,
      useFacetParam: searchUsesConvermaxFacetParam(currentSearch) || convermaxPreservedQueryParams(currentSearch).length > 0,
    });
    var nextUrl = String(window.location.pathname || '/') + (query ? '?' + query : '') + String(window.location.hash || '');

    try {
      window.history?.replaceState?.(window.history.state, document.title, nextUrl);
    } catch (_error) {
      // If history is unavailable, generated Product links will still use canonical tokens.
    }
  }

  function convermaxFilterUrl(field, value) {
    var path = arguments.length > 2 && arguments[2] ? arguments[2] : (window.location.pathname || '/');
    var options = arguments.length > 3 ? arguments[3] : {};
    var values = Array.isArray(value) ? value : [value];
    var parts = options?.preserveCurrentQuery ? convermaxCurrentQueryParts(field) : [];

    values.filter(Boolean).forEach(function (item) {
      parts.push({ field: field, value: item });
    });

    var currentSearch = window.location.search || '';
    var query = buildConvermaxLocationQuery(parts, {
      preserveCurrentQuery: options?.preserveCurrentQuery,
      useFacetParam: options?.preserveCurrentQuery
        && (searchUsesConvermaxFacetParam(currentSearch) || convermaxPreservedQueryParams(currentSearch).length > 0),
    });

    return query ? path + '?' + query : path;
  }

  function isConvermaxFilterSelected(field, value) {
    if (field === productTypeV3FacetField) {
      var target = parseProductTypeV3Token(value);
      var targetSignature = productTypeV3ActiveFilterSignature(target);
      if (targetSignature) {
        return convermaxCurrentFilterValues(field).some(function (currentValue) {
          return productTypeV3ActiveFilterSignature(parseProductTypeV3Token(currentValue)) === targetSignature;
        });
      }
    }

    var encoded = field + '/' + encodeURIComponent(String(value || ''));
    var rawLocation = String(window.location.pathname || '') + String(window.location.search || '');
    if (rawLocation.indexOf(encoded) !== -1) return true;

    try {
      return decodeURIComponent(rawLocation).indexOf(field + '/' + String(value || '')) !== -1;
    } catch (_error) {
      return false;
    }
  }

  function decodeProductTypeV3TokenValue(value) {
    var text = String(value || '')
      .replace(/\+/g, '%20')
      .replace(/-(20|23|25|26|2b|2B|2f|2F|3d|3D|3f|3F)/g, '%$1');

    try {
      return decodeURIComponent(text.replace(/%(?![0-9a-f]{2})/gi, '%25'));
    } catch (_error) {
      return String(value || '');
    }
  }

  function productTypeV3TokenFromString(value) {
    var tokenPattern = /v3\|cat=[^|]+\|v=[^|]+\|cat_label=[^|]+\|label=[^|]+\|sort=\d+/;
    var raw = String(value || '');
    var rawMatch = raw.match(tokenPattern);
    if (rawMatch) return rawMatch[0];

    var decoded = decodeProductTypeV3TokenValue(raw);
    var decodedMatch = decoded.match(tokenPattern);
    return decodedMatch ? decodedMatch[0] : '';
  }

  function encodeProductTypeV3QueryTokenValue(value) {
    var decoded = decodeProductTypeV3TokenValue(value);
    return encodeURIComponent(decoded).replace(/%/g, '-');
  }

  function parseProductTypeV3Token(token) {
    var rawToken = productTypeV3TokenFromString(token);
    if (!rawToken) return null;

    var segments = rawToken.split('|');
    if (segments.shift() !== 'v3') return null;

    var parsed = {
      token: rawToken,
    };

    segments.forEach(function (segment) {
      var separatorIndex = segment.indexOf('=');
      if (separatorIndex <= 0) return;

      var key = segment.slice(0, separatorIndex);
      var value = segment.slice(separatorIndex + 1);
      parsed[key] = value;
    });

    if (!parsed.cat || !parsed.v || !parsed.cat_label || !parsed.label) return null;

    return {
      token: rawToken,
      cat: decodeProductTypeV3TokenValue(parsed.cat),
      slug: decodeProductTypeV3TokenValue(parsed.v),
      catLabel: decodeUserSurfaceText(decodeProductTypeV3TokenValue(parsed.cat_label), { decodePlusAsSpace: true }),
      label: decodeUserSurfaceText(decodeProductTypeV3TokenValue(parsed.label), { decodePlusAsSpace: true }),
      sort: String(parsed.sort || '999').replace(/[^\d]/g, '') || '999',
    };
  }

  function productTypeV3TokenForQuery(token) {
    var parsed = parseProductTypeV3Token(token);
    if (!parsed) return '';

    return [
      'v3',
      'cat=' + encodeProductTypeV3QueryTokenValue(parsed.cat),
      'v=' + encodeProductTypeV3QueryTokenValue(parsed.slug),
      'cat_label=' + encodeProductTypeV3QueryTokenValue(parsed.catLabel),
      'label=' + encodeProductTypeV3QueryTokenValue(parsed.label),
      'sort=' + parsed.sort,
    ].join('|');
  }

  function isProductTypeV3RollupToken(parsed) {
    if (!parsed) return true;

    return /^all\s+/i.test(parsed.label);
  }

  function isProductTypeV3SuppressedToken(parsed) {
    if (!parsed) return false;

    return [parsed.cat, parsed.catLabel, parsed.label, parsed.slug].some(function (value) {
      return productTypeV3SuppressedLabels.indexOf(clean(value)) !== -1;
    });
  }

  function productTypeV3CanonicalCategory(parsed) {
    var parentIndex = productTypeV3ParentCategoryIndexByHandle[parsed?.cat || ''];
    var parent = Number.isInteger(parentIndex) ? productTypeV3ParentCategories[parentIndex] : null;

    if (!parent) {
      return {
        handle: parsed.cat,
        title: parsed.catLabel,
        order: 9999,
      };
    }

    return {
      handle: parent[0],
      title: parent[1],
      order: parent[2],
    };
  }

  function productTypeV3OptionAlias(parsed) {
    var alias = productTypeV3HelmetOptionAliasesByHandle[parsed?.cat || ''];
    if (!alias) return null;

    return {
      slug: alias[0],
      label: alias[1],
      sort: alias[2],
    };
  }

  function productTypeV3RawFacetCandidates(root) {
    var selectors = [
      '.cm_field-' + productTypeV3FacetField,
      '[data-field="' + productTypeV3FacetField + '"]',
      '[data-cm-field="' + productTypeV3FacetField + '"]',
    ].join(',');

    return Array.from((root || document).querySelectorAll?.(selectors) || []).filter(function (facet) {
      return !facet.matches?.('[data-parity-product-type-v3-filter-source], [data-parity-product-type-v3-filter-clone], .parity-cm-product-type-v3-facet')
        && !facet.closest?.('[data-parity-product-type-v3-filter-source], [data-parity-product-type-v3-filter-clone], .parity-cm-product-type-v3-facet');
    });
  }

  function hideProductTypeV3RawFacets(root) {
    productTypeV3RawFacetCandidates(root || document).forEach(function (facet) {
      facet.dataset.parityProductTypeV3RawSource = 'true';
      facet.hidden = true;
      facet.setAttribute('aria-hidden', 'true');
      facet.style.setProperty('display', 'none', 'important');
    });
  }

  function hideMobileSupersededProductTypeFacets(root) {
    if (!root?.closest?.('#cm_FacetDialog, .FacetDialog')) return;

    var selectors = [
      '.cm_field-custom_product_type_v2',
      '[data-field="custom_product_type_v2"]',
      '[data-cm-field="custom_product_type_v2"]',
    ].join(',');

    Array.from(root.querySelectorAll?.(selectors) || []).forEach(function (facet) {
      facet.dataset.parityProductTypeV3Superseded = 'true';
      facet.hidden = true;
      facet.setAttribute('aria-hidden', 'true');
      facet.style.setProperty('display', 'none', 'important');
    });
  }

  function productTypeV3TokenFromHref(href) {
    var rawHref = String(href || '');
    var marker = productTypeV3FacetField + '/';
    var markerIndex = rawHref.indexOf(marker);
    if (markerIndex === -1) return '';

    return productTypeV3TokenFromString(rawHref.slice(markerIndex + marker.length));
  }

  function productTypeV3CountFromFacetRow(row) {
    var countNode = row?.querySelector?.('.facetentryval, .facetentrycount, .facetcount, .cm_facet-value-count, [data-cm-role="facet-count"]');
    var text = countNode?.textContent || '';
    var count = parseInt(String(text).replace(/[^\d]/g, ''), 10);

    return Number.isFinite(count) ? count : null;
  }

  function productTypeV3TokenFromFacetRow(row) {
    var link = row?.querySelector?.('.facetentrykey[href], a[href]') || row?.querySelector?.('.facetentrykey, [data-value]');
    var hrefToken = productTypeV3TokenFromHref(link?.getAttribute?.('href') || '');
    if (parseProductTypeV3Token(hrefToken)) return hrefToken;

    var dataValue = productTypeV3TokenFromString(link?.getAttribute?.('data-value') || row?.getAttribute?.('data-value') || '');
    if (parseProductTypeV3Token(dataValue)) return dataValue;

    var countNode = row?.querySelector?.('.facetentryval, .facetentrycount, .facetcount, .cm_facet-value-count, [data-cm-role="facet-count"]');
    var text = (link?.textContent || row?.textContent || '').trim();
    if (countNode?.textContent) text = text.replace(countNode.textContent, '').trim();

    return productTypeV3TokenFromString(text);
  }

  function expandProductTypeV3RawFacetOptions(facet) {
    if (!facet || facet.dataset.parityProductTypeV3ShowAllClicked === 'true') return false;

    var showAll = Array.from(facet.querySelectorAll('.cm_show-all, [data-cm-role="show-more"]')).find(function (control) {
      return /show\s+more/i.test(control.textContent || '');
    });
    if (!showAll) return false;

    facet.dataset.parityProductTypeV3ShowAllClicked = 'true';
    try {
      showAll.click();
    } catch (_error) {
      // Theme click observers can throw on synthetic Convermax controls in Chrome.
    }
    window.setTimeout(scheduleSortAll, 50);
    window.setTimeout(scheduleSortAll, 250);
    window.setTimeout(scheduleSortAll, 700);
    return true;
  }

  function productTypeV3RowsFromRawFacets(root) {
    var rows = [];

    productTypeV3RawFacetCandidates(root || document).forEach(function (facet) {
      facet.dataset.parityProductTypeV3RawSource = 'true';
      var showAllRequested = expandProductTypeV3RawFacetOptions(facet);
      facet.hidden = true;

      if (showAllRequested && Array.from(facet.querySelectorAll('.cm_show-all, [data-cm-role="show-more"]')).some(function (control) {
        return /show\s+more/i.test(control.textContent || '');
      })) {
        return;
      }

      Array.from(facet.querySelectorAll('.facetdiv, [role="listitem"]')).forEach(function (row) {
        var token = productTypeV3TokenFromFacetRow(row);
        if (!token) return;

        rows.push({
          token: token,
          count: productTypeV3CountFromFacetRow(row),
          sourceIndex: rows.length,
        });
      });
    });

    return rows;
  }

  function productTypeV3GroupsFromRows(rows) {
    var groupMap = new Map();

    rows.forEach(function (row) {
      var parsed = parseProductTypeV3Token(row.token);
      if (isProductTypeV3RollupToken(parsed)) return;
      if (isProductTypeV3SuppressedToken(parsed)) return;
      var canonical = productTypeV3CanonicalCategory(parsed);

      var group = groupMap.get(canonical.handle);
      if (!group) {
        group = {
          title: canonical.title,
          handle: canonical.handle,
          handles: [canonical.handle],
          aliases: [],
          options: [],
          optionMap: new Map(),
          sortOrder: canonical.order,
          sourceIndex: row.sourceIndex,
        };
        groupMap.set(canonical.handle, group);
      }

      if (parsed.cat && group.handles.indexOf(parsed.cat) === -1) {
        group.handles.push(parsed.cat);
      }

      var optionAlias = productTypeV3OptionAlias(parsed);
      var optionSlug = optionAlias?.slug || parsed.slug;
      var optionLabel = optionAlias?.label || parsed.label;
      var optionSort = optionAlias?.sort || parsed.sort;
      var optionKey = optionSlug || clean(optionLabel);
      var existingOption = group.optionMap.get(optionKey);
      if (existingOption) {
        if (existingOption.tokens.indexOf(parsed.token) === -1) {
          existingOption.tokens.push(parsed.token);
        }
        if (typeof row.count === 'number') {
          existingOption.count = typeof existingOption.count === 'number'
            ? existingOption.count + row.count
            : row.count;
        }
        if (String(optionSort).localeCompare(String(existingOption.sort), undefined, { numeric: true }) < 0) {
          existingOption.sort = optionSort;
        }
        return;
      }

      var option = {
        token: parsed.token,
        tokens: [parsed.token],
        label: optionLabel,
        slug: optionSlug,
        sort: optionSort,
        count: row.count,
        sourceIndex: row.sourceIndex,
      };
      group.optionMap.set(optionKey, option);
      group.options.push(option);
    });

    return Array.from(groupMap.values())
      .sort(function (left, right) {
        return left.sortOrder - right.sortOrder || left.sourceIndex - right.sourceIndex;
      })
      .map(function (group) {
        group.options.sort(function (left, right) {
          return String(left.sort).localeCompare(String(right.sort), undefined, { numeric: true })
            || left.label.localeCompare(right.label)
            || left.sourceIndex - right.sourceIndex;
        });
        delete group.optionMap;
        return group;
      });
  }

  function productTypeV3FacetGroups(root) {
    return productTypeV3GroupsFromRows(productTypeV3RowsFromRawFacets(root || document));
  }

  function productTypeV3GroupMatchesText(group, text) {
    var normalizedText = clean(text);
    if (!normalizedText) return false;

    if (clean(group.title) === normalizedText) return true;

    return (group.aliases || []).some(function (alias) {
      return clean(alias) === normalizedText;
    });
  }

  function productTypeV3GroupMatchesHandle(group, path) {
    var normalizedPath = clean(path);
    if (!normalizedPath) return false;

    if (group.handle && normalizedPath.indexOf(clean(group.handle)) !== -1) return true;

    return (group.handles || []).some(function (handle) {
      return normalizedPath.indexOf(clean(handle)) !== -1;
    });
  }

  function productTypeV3PrimaryCategoryTexts(root) {
    var scope = root || document;
    var values = [];

    document.querySelectorAll('[data-parity-primary-category]').forEach(function (node) {
      values.push(node.getAttribute('data-parity-primary-category') || '');
    });

    scope.querySelectorAll?.('[data-parity-primary-category]').forEach(function (node) {
      values.push(node.getAttribute('data-parity-primary-category') || '');
    });

    document.querySelectorAll('.parity-category-breadcrumbs').forEach(function (breadcrumbs) {
      var foundMotorcycleRoot = false;

      breadcrumbs.querySelectorAll('.parity-category-breadcrumbs__link, .parity-category-breadcrumbs__current').forEach(function (node) {
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;

        if (foundMotorcycleRoot) {
          values.push(text);
          foundMotorcycleRoot = false;
          return;
        }

        if (clean(text) === 'motorcycle parts') {
          foundMotorcycleRoot = true;
        }
      });
    });

    document.querySelectorAll('.parity-category-tree__title, .parity-moto-product-header__title, h1.collection--title').forEach(function (node) {
      values.push(node.textContent || '');
    });

    return values.map(function (value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
  }

  function productTypeV3PrimaryGroup(root, groups) {
    var path = window.location.pathname || '';
    var availableGroups = groups || [];
    var byHandle = availableGroups.find(function (group) {
      return productTypeV3GroupMatchesHandle(group, path);
    });
    if (byHandle) return byHandle;

    var texts = productTypeV3PrimaryCategoryTexts(root);
    for (var textIndex = 0; textIndex < texts.length; textIndex += 1) {
      var match = availableGroups.find(function (group) {
        return productTypeV3GroupMatchesText(group, texts[textIndex]);
      });
      if (match) return match;
    }

    return availableGroups[0] || null;
  }

  function productTypeV3FacetSignature(primaryGroup, groups) {
    return [
      productTypeV3FacetVersion,
      primaryGroup?.title || '',
      primaryGroup?.renderMode || '',
      (groups || []).map(function (group) {
        return [
          group.handle || '',
          group.title || '',
          (group.options || []).map(function (option) {
            return [(option.tokens || [option.token]).join(','), option.count].join(':');
          }).join(','),
        ].join(':');
      }).join('\u0002'),
      window.location.pathname || '',
      window.location.search || '',
    ].join('\u0000');
  }

  function createProductTypeV3Facet() {
    var facet = document.createElement('nav');
    facet.className = 'facetholder parity-cm-product-type-v3-facet cm_field-' + productTypeV3FacetField;
    facet.setAttribute('aria-label', 'Product');
    facet.dataset.parityProductTypeV3FilterSource = 'true';
    facet.dataset.parityProductTypeV3FilterField = productTypeV3FacetField;
    return facet;
  }

  function setProductTypeV3GroupExpanded(group, expanded, animate) {
    var toggle = group?.querySelector?.('[data-parity-product-type-v3-group-toggle]');
    var options = group?.querySelector?.('[data-parity-product-type-v3-group-options]');
    if (!toggle || !options) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    setFacetBodyExpanded(options, expanded, Boolean(animate));
    group.classList.toggle('parity-cm-product-type-v3-facet__group--expanded', expanded);
    group.classList.toggle('parity-cm-product-type-v3-facet__group--collapsed', !expanded);
  }

  function productTypeV3OptionTokens(option) {
    var values = Array.isArray(option?.tokens) && option.tokens.length ? option.tokens : [option?.token];
    return values.filter(Boolean);
  }

  function productTypeV3PreferredOptionToken(option, group) {
    var values = productTypeV3OptionTokens(option);
    var currentPath = clean(window.location.pathname || '');
    var groupHandle = clean(group?.handle || '');
    var pathMatchedValue = values.find(function (candidate) {
      var parsed = parseProductTypeV3Token(candidate);
      var tokenCategory = clean(parsed?.cat || '');

      return tokenCategory && tokenCategory !== groupHandle && currentPath.indexOf(tokenCategory) !== -1;
    });

    return pathMatchedValue || values[0] || option?.token || '';
  }

  function productTypeV3OptionFilterSignatures(values) {
    return new Set((values || []).map(function (value) {
      return productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value));
    }).filter(Boolean));
  }

  function productTypeV3OptionFilterValues(option) {
    var optionValues = productTypeV3OptionTokens(option).map(productTypeV3TokenForQuery).filter(Boolean);
    var optionSignatures = productTypeV3OptionFilterSignatures(optionValues);
    var currentValues = convermaxCurrentFilterValues(productTypeV3FacetField).map(productTypeV3TokenForQuery).filter(Boolean);
    var selected = currentValues.some(function (value) {
      return optionSignatures.has(productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value)));
    });

    if (selected) {
      return currentValues.filter(function (value) {
        return !optionSignatures.has(productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value)));
      });
    }

    var combinedValues = currentValues.slice();
    optionValues.forEach(function (value) {
      var exists = combinedValues.some(function (currentValue) {
        return currentValue === value;
      });

      if (!exists) combinedValues.push(value);
    });

    return combinedValues;
  }

  function productTypeV3OptionValuesFromLink(link) {
    var values = String(link?.dataset?.parityProductTypeV3Values || '')
      .split('\u0002')
      .filter(Boolean);
    if (values.length) return values;

    var value = link?.dataset?.parityProductTypeV3Value || '';
    return value ? [value] : [];
  }

  function scheduleProductTypeV3FilterRefreshes() {
    [0, 80, 220, 600, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        scheduleSortAll();
        normalizeFilterChrome(document);
      }, delay);
    });
  }

  function productTypeV3NextFilterValuesForValues(values) {
    var optionValues = (values || []).map(productTypeV3TokenForQuery).filter(Boolean);
    var optionSignatures = productTypeV3OptionFilterSignatures(optionValues);
    var currentValues = convermaxCurrentFilterValues(productTypeV3FacetField).map(productTypeV3TokenForQuery).filter(Boolean);
    var selected = currentValues.some(function (value) {
      return optionSignatures.has(productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value)));
    });

    if (selected) {
      return currentValues.filter(function (value) {
        return !optionSignatures.has(productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value)));
      });
    }

    var combinedValues = currentValues.slice();
    optionValues.forEach(function (value) {
      if (combinedValues.indexOf(value) === -1) combinedValues.push(value);
    });

    return combinedValues;
  }

  function dispatchConvermaxPopState() {
    var event;

    try {
      event = new PopStateEvent('popstate', { state: window.history?.state });
    } catch (_error) {
      event = document.createEvent('Event');
      event.initEvent('popstate', true, true);
    }

    window.dispatchEvent(event);
  }

  function applyProductTypeV3FilterValues(values) {
    var nextValues = productTypeV3NextFilterValuesForValues(values);
    var nextUrl = convermaxFilterUrl(productTypeV3FacetField, nextValues, window.location.pathname || '/', { preserveCurrentQuery: true });
    var nextPath = nextUrl + String(window.location.hash || '');
    var currentPath = String(window.location.pathname || '/') + String(window.location.search || '') + String(window.location.hash || '');

    if (nextPath === currentPath) return false;

    window.history?.pushState?.(window.history.state, document.title, nextPath);
    dispatchConvermaxPopState();
    scheduleProductTypeV3FilterRefreshes();
    return true;
  }

  function removeProductTypeV3FilterSignature(signature) {
    if (!signature) return false;

    var currentValues = convermaxCurrentFilterValues(productTypeV3FacetField).map(productTypeV3TokenForQuery).filter(Boolean);
    var nextValues = currentValues.filter(function (value) {
      return productTypeV3ActiveFilterSignature(parseProductTypeV3Token(value)) !== signature;
    });
    if (nextValues.length === currentValues.length) return false;

    var nextUrl = convermaxFilterUrl(productTypeV3FacetField, nextValues, window.location.pathname || '/', { preserveCurrentQuery: true });
    var nextPath = nextUrl + String(window.location.hash || '');
    var currentPath = String(window.location.pathname || '/') + String(window.location.search || '') + String(window.location.hash || '');
    if (nextPath === currentPath) return false;

    window.history?.pushState?.(window.history.state, document.title, nextPath);
    dispatchConvermaxPopState();
    scheduleProductTypeV3FilterRefreshes();
    return true;
  }

  function handleProductTypeV3OptionActivation(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.type === 'click' && event.button && event.button !== 0) return;

    var link = event.target?.closest?.('.parity-cm-product-type-v3-facet__link');
    if (!link) return;

    var values = productTypeV3OptionValuesFromLink(link);
    var signatures = productTypeV3OptionFilterSignatures(values);
    if (!signatures.size) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    applyProductTypeV3FilterValues(values);
  }

  function productTypeV3CollectionHandleFromPath(path) {
    var match = String(path || '').match(/^\/collections\/([^/?#]+)\/?$/i);
    if (!match) return '';

    try {
      return decodeURIComponent(match[1]);
    } catch (_error) {
      return match[1];
    }
  }

  function productTypeV3KnownCollectionHandle(handle) {
    if (!handle) return false;
    if (handle === 'motorcycle-parts') return true;
    if (/^motorcycle-/i.test(handle)) return true;

    return Number.isInteger(productTypeV3ParentCategoryIndexByHandle[handle]);
  }

  function productTypeV3CollectionBelongsToGroup(collectionHandle, groupHandle) {
    if (!collectionHandle || !groupHandle) return false;
    if (collectionHandle === groupHandle) return true;

    var parentIndex = productTypeV3ParentCategoryIndexByHandle[collectionHandle];
    var parent = Number.isInteger(parentIndex) ? productTypeV3ParentCategories[parentIndex] : null;

    return parent?.[0] === groupHandle;
  }

  function productTypeV3CategoryContextGroup(root, groups) {
    var currentHandle = productTypeV3CollectionHandleFromPath(window.location.pathname || '');
    if (!currentHandle || currentHandle === 'motorcycle-parts') return null;
    if (!Number.isInteger(productTypeV3ParentCategoryIndexByHandle[currentHandle])) return null;

    return (groups || []).find(function (group) {
      return productTypeV3CollectionBelongsToGroup(currentHandle, group.handle);
    }) || null;
  }

  function productTypeV3FilterPath(group) {
    var path = window.location.pathname || '/';
    var handle = String(group?.handle || '').trim();
    if (!handle) return path;

    var currentHandle = productTypeV3CollectionHandleFromPath(path);
    if (!productTypeV3KnownCollectionHandle(currentHandle)) return path;
    if (productTypeV3CollectionBelongsToGroup(currentHandle, handle)) return path;

    return '/collections/' + encodeURIComponent(handle);
  }

  function renderProductTypeV3Option(option, list, group, renderOptions) {
    var settings = renderOptions || {};
    var label = decodeUserSurfaceText(option.label, { decodePlusAsSpace: true });
    var values = productTypeV3OptionTokens(option);
    var value = productTypeV3TokenForQuery(productTypeV3PreferredOptionToken(option, group));
    var hrefValues = productTypeV3OptionFilterValues(option);
    var count = settings.showCount && typeof option.count === 'number' ? option.count : null;
    var selected = values.some(function (candidate) {
      return isConvermaxFilterSelected(productTypeV3FacetField, candidate);
    });
    var item = document.createElement('div');
    item.className = 'facetdiv parity-cm-product-type-v3-facet__option';
    item.setAttribute('role', 'listitem');
    item.classList.toggle('parity-cm-product-type-v3-facet__option--selected', selected);

    var link = document.createElement('a');
    link.className = 'facetentrykey parity-cm-product-type-v3-facet__link';
    link.href = convermaxFilterUrl(productTypeV3FacetField, hrefValues, window.location.pathname || '/', { preserveCurrentQuery: true });
    link.dataset.parityProductTypeV3Value = value;
    if (values.length > 1) link.dataset.parityProductTypeV3Values = values.map(productTypeV3TokenForQuery).filter(Boolean).join('\u0002');
    link.dataset.parityProductTypeV3Slug = option.slug || '';
    if (selected) link.setAttribute('aria-current', 'page');

    var checkbox = document.createElement('span');
    checkbox.className = 'parity-cm-product-type-v3-facet__checkbox';
    checkbox.setAttribute('aria-hidden', 'true');
    link.appendChild(checkbox);

    var labelNode = document.createElement('span');
    labelNode.className = 'parity-cm-product-type-v3-facet__option-label';
    var labelText = document.createElement('span');
    labelText.className = 'parity-cm-product-type-v3-facet__option-text';
    labelText.textContent = label;
    labelNode.appendChild(labelText);
    link.appendChild(labelNode);

    if (typeof count === 'number') {
      var countNode = document.createElement('span');
      countNode.className = 'facetentryval parity-cm-product-type-v3-facet__count';
      countNode.textContent = ' (' + count + ')';
      labelNode.appendChild(countNode);
    }

    item.appendChild(link);
    list.appendChild(item);
  }

  function productTypeV3FlatSearchTerms(value) {
    var words = clean(value).split(' ').filter(Boolean);
    var terms = words.slice();

    words.forEach(function (word) {
      if (word.length > 5 && /ing$/.test(word)) {
        var stem = word.slice(0, -3) + 'e';
        if (terms.indexOf(stem) === -1) terms.push(stem);
      }
    });

    return terms;
  }

  function filterProductTypeV3FlatOptions(facet) {
    var input = facet?.querySelector?.('[data-parity-product-type-v3-search]');
    var queryTerms = clean(input?.value || '').split(' ').filter(Boolean);

    facet?.querySelectorAll?.('[data-parity-product-type-v3-flat-options] .parity-cm-product-type-v3-facet__option').forEach(function (option) {
      var label = option.querySelector?.('.parity-cm-product-type-v3-facet__option-text')?.textContent || option.textContent || '';
      var optionTerms = productTypeV3FlatSearchTerms(label).join(' ');
      option.hidden = queryTerms.length > 0 && !queryTerms.every(function (term) {
        return optionTerms.indexOf(term) !== -1;
      });
    });
  }

  function productTypeV3GroupHasSelectedOption(group) {
    return (group.options || []).some(function (option) {
      return productTypeV3OptionTokens(option).some(function (candidate) {
        return isConvermaxFilterSelected(productTypeV3FacetField, candidate);
      });
    });
  }

  function renderProductTypeV3Facet(facet, root, groups) {
    var productGroups = groups || [];
    var primaryGroup = productTypeV3PrimaryGroup(root, productGroups);
    var categoryGroup = productTypeV3CategoryContextGroup(root, productGroups);
    var renderMode = categoryGroup ? 'category-flat' : 'grouped';
    if (categoryGroup) {
      primaryGroup = Object.assign({}, categoryGroup, { renderMode: renderMode });
    }
    var signature = productTypeV3FacetSignature(primaryGroup, productGroups);
    if (facet.dataset.parityProductTypeV3FilterSignature === signature) return;

    var expanded = facet.querySelector('[data-parity-product-type-v3-filter-toggle]')?.getAttribute('aria-expanded') !== 'false';
    var previousSearchValue = facet.querySelector('[data-parity-product-type-v3-search]')?.value || '';
    var previousGroupStates = new Map();

    facet.querySelectorAll('[data-parity-product-type-v3-group]').forEach(function (group) {
      previousGroupStates.set(
        group.getAttribute('data-parity-product-type-v3-group') || '',
        group.querySelector('[data-parity-product-type-v3-group-toggle]')?.getAttribute('aria-expanded') === 'true'
      );
    });

    facet.textContent = '';
    facet.dataset.parityProductTypeV3FilterSignature = signature;
    facet.dataset.parityProductTypeV3FilterMode = renderMode;
    delete facet.dataset.parityProductTypeV3FilterBound;
    delete facet.dataset.parityProductTypeV3GroupBound;

    var title = document.createElement('div');
    title.className = 'facettitle parity-cm-product-type-v3-facet__title';
    title.setAttribute('role', 'button');
    title.tabIndex = 0;
    title.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    title.dataset.parityProductTypeV3FilterToggle = 'true';

    var titleMain = document.createElement('span');
    titleMain.textContent = 'Product';
    title.appendChild(titleMain);
    facet.appendChild(title);

    var body = document.createElement('div');
    body.className = 'facetbody parity-cm-product-type-v3-facet__body';
    body.dataset.parityProductTypeV3FilterBody = 'true';
    body.hidden = !expanded;

    if (categoryGroup) {
      var search = document.createElement('div');
      search.className = 'parity-cm-product-type-v3-facet__search';

      var searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.className = 'parity-cm-product-type-v3-facet__search-input';
      searchInput.placeholder = 'Search by Product';
      searchInput.setAttribute('aria-label', 'Search by Product');
      searchInput.dataset.parityProductTypeV3Search = 'true';
      searchInput.value = previousSearchValue;
      search.appendChild(searchInput);

      var searchIcon = document.createElement('span');
      searchIcon.className = 'parity-cm-product-type-v3-facet__search-icon';
      searchIcon.setAttribute('aria-hidden', 'true');
      search.appendChild(searchIcon);
      body.appendChild(search);

      var flatOptions = document.createElement('div');
      flatOptions.className = 'cmTemplate_simpleFacet parity-cm-product-type-v3-facet__options parity-cm-product-type-v3-facet__options--flat';
      flatOptions.dataset.parityProductTypeV3FlatOptions = 'true';
      flatOptions.setAttribute('role', 'list');

      (categoryGroup.options || []).forEach(function (option) {
        renderProductTypeV3Option(option, flatOptions, categoryGroup, { showCount: true });
      });

      body.appendChild(flatOptions);
      facet.appendChild(body);
      filterProductTypeV3FlatOptions(facet);
      return;
    }

    productGroups.forEach(function (group, groupIndex) {
      var groupNode = document.createElement('div');
      groupNode.className = 'parity-cm-product-type-v3-facet__group';
      groupNode.dataset.parityProductTypeV3Group = decodeUserSurfaceText(group.title, { decodePlusAsSpace: true });
      groupNode.dataset.parityProductTypeV3Category = group.handle || '';

      var groupToggle = document.createElement('button');
      groupToggle.type = 'button';
      groupToggle.className = 'parity-cm-product-type-v3-facet__group-toggle';
      groupToggle.dataset.parityProductTypeV3GroupToggle = 'true';

      var groupTitle = document.createElement('span');
      groupTitle.className = 'parity-cm-product-type-v3-facet__group-title';
      groupTitle.textContent = decodeUserSurfaceText(group.title, { decodePlusAsSpace: true });
      groupToggle.appendChild(groupTitle);
      groupNode.appendChild(groupToggle);

      var options = document.createElement('div');
      options.className = 'cmTemplate_simpleFacet parity-cm-product-type-v3-facet__options';
      options.dataset.parityProductTypeV3GroupOptions = 'true';
      options.setAttribute('role', 'list');

      (group.options || []).forEach(function (option) {
        renderProductTypeV3Option(option, options, group);
      });

      groupNode.appendChild(options);
      body.appendChild(groupNode);

      var expandedGroup = previousGroupStates.has(group.title)
        ? previousGroupStates.get(group.title)
        : productTypeV3GroupHasSelectedOption(group);
      setProductTypeV3GroupExpanded(groupNode, expandedGroup, false);
    });

    facet.appendChild(body);
  }

  function bindProductTypeV3Facet(facet) {
    bindSyntheticFacet(facet, {
      boundDataset: 'parityProductTypeV3FilterBound',
      toggleSelector: '[data-parity-product-type-v3-filter-toggle]',
      bodySelector: '[data-parity-product-type-v3-filter-body]',
    });

    if (!facet || facet.dataset.parityProductTypeV3GroupBound === 'true') return;
    facet.dataset.parityProductTypeV3GroupBound = 'true';

    var handleGroupToggle = function (event) {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;

      var toggle = event.target?.closest?.('[data-parity-product-type-v3-group-toggle]');
      if (!toggle || !facet.contains(toggle)) return;

      var group = toggle.closest('[data-parity-product-type-v3-group]');
      if (!group) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setProductTypeV3GroupExpanded(group, toggle.getAttribute('aria-expanded') !== 'true', true);
    };

    facet.addEventListener('click', handleGroupToggle);
    facet.addEventListener('keydown', handleGroupToggle);
    facet.addEventListener('input', function (event) {
      var input = event.target?.closest?.('[data-parity-product-type-v3-search]');
      if (!input || !facet.contains(input)) return;

      filterProductTypeV3FlatOptions(facet);
    });
  }

  function removeSearchCategoryFacetSources() {
    document.querySelectorAll('[data-parity-search-category-filter-source], [data-parity-search-category-filter-clone]').forEach(function (facet) {
      facet.remove();
    });
  }

  function ensureSearchCategoryFacetSource() {
    var root = document.querySelector('#cm_SearchPage');
    if (!root) return null;

    var target = root.querySelector('.cm_FacetPanel:not(.dialog-body) .cmRepeater_facets');
    var categories = searchCategoryCandidates(root);
    var facet = root.querySelector('[data-parity-search-category-filter-source]');

    if (!target || !categories.length) {
      removeSearchCategoryFacetSources();
      return null;
    }

    if (!facet) facet = createSearchCategoryFacet();
    renderSearchCategoryFacet(facet, categories);
    insertCategoryFacet(target, facet);
    return facet;
  }

  function insertCategoryFacet(target, facet) {
    if (!target || !facet) return;

    if (facet.parentElement !== target || target.firstElementChild !== facet) {
      target.insertBefore(facet, target.firstElementChild);
    }

    bindCategoryFacet(facet);
  }

  function primaryFacetTarget() {
    return document.querySelector([
      '#cm_results .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-collection-page .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-collection-list .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-brand-list .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm_SearchPage .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
    ].join(','));
  }

  function productTypeV3InsertAnchor(target, facet) {
    var categoryFacet = Array.from(target.children).find(function (child) {
      return child !== facet && child.matches?.('[data-parity-category-filter-source], [data-parity-category-filter-clone], .parity-cm-category-facet');
    });

    if (categoryFacet) return categoryFacet.nextElementSibling;

    return target.firstElementChild;
  }

  function insertProductTypeV3Facet(target, facet) {
    if (!target || !facet) return;

    var anchor = productTypeV3InsertAnchor(target, facet);
    if (facet.parentElement !== target || anchor !== facet) {
      target.insertBefore(facet, anchor || null);
    }

    bindProductTypeV3Facet(facet);
  }

  function removeProductTypeV3FacetSources() {
    document.querySelectorAll('[data-parity-product-type-v3-filter-source], [data-parity-product-type-v3-filter-clone]').forEach(function (facet) {
      facet.remove();
    });
  }

  function ensureProductTypeV3FacetSource() {
    var target = primaryFacetTarget();
    if (!target) {
      removeProductTypeV3FacetSources();
      return null;
    }

    var root = target.closest(productRootSelector) || document;
    var groups = productTypeV3FacetGroups(root);
    if (!groups.length) {
      removeProductTypeV3FacetSources();
      return null;
    }

    var facet = target.querySelector('[data-parity-product-type-v3-filter-source]')
      || document.querySelector('[data-parity-product-type-v3-filter-source]');

    if (!facet) facet = createProductTypeV3Facet();
    renderProductTypeV3Facet(facet, root, groups);
    insertProductTypeV3Facet(target, facet);
    hideProductTypeV3RawFacets(root);
    return facet;
  }

  function syncProductTypeV3FacetDialogClone(source) {
    document.querySelectorAll('#cm_FacetDialog .cmRepeater_facets').forEach(function (target) {
      var existing = Array.from(target.children).find(function (child) {
        return child.matches?.('[data-parity-product-type-v3-filter-source], [data-parity-product-type-v3-filter-clone]');
      });
      var created = false;
      var sourceSignature = source.dataset.parityProductTypeV3FilterSignature || '';

      if (!existing) {
        existing = source.cloneNode(true);
        created = true;
      } else if (existing.dataset.parityProductTypeV3FilterSignature !== sourceSignature) {
        var replacement = source.cloneNode(true);
        existing.replaceWith(replacement);
        existing = replacement;
        created = true;
      }

      existing.removeAttribute('data-parity-product-type-v3-filter-source');
      existing.dataset.parityProductTypeV3FilterClone = 'true';
      existing.dataset.parityProductTypeV3FilterSignature = sourceSignature;
      if (created) {
        existing.dataset.parityProductTypeV3FilterBound = 'false';
        existing.dataset.parityProductTypeV3GroupBound = 'false';
      }
      insertProductTypeV3Facet(target, existing);

      Array.from(target.querySelectorAll('[data-parity-product-type-v3-filter-clone]')).forEach(function (candidate) {
        if (candidate !== existing) candidate.remove();
      });
      hideProductTypeV3RawFacets(target);
      hideMobileSupersededProductTypeFacets(target);
    });
  }

  function syncProductTypeV3Facets() {
    var source = ensureProductTypeV3FacetSource();
    if (!source) return;

    syncProductTypeV3FacetDialogClone(source);
  }

  function syncCategoryFacetDialogClone(source) {
    document.querySelectorAll('#cm_FacetDialog .cmRepeater_facets').forEach(function (target) {
      var existing = Array.from(target.children).find(function (child) {
        return child.matches?.('[data-parity-category-filter-source], [data-parity-category-filter-clone]');
      });
      var created = false;
      var sourceSignature = source.dataset.parityCategoryFilterSignature || '';

      if (!existing) {
        existing = source.cloneNode(true);
        created = true;
      } else if (
        source.dataset.paritySearchCategoryFilterSource === 'true'
        && existing.dataset.parityCategoryFilterSignature !== sourceSignature
      ) {
        var replacement = source.cloneNode(true);
        existing.replaceWith(replacement);
        existing = replacement;
        created = true;
      }

      existing.removeAttribute('data-parity-category-filter-source');
      existing.removeAttribute('data-parity-search-category-filter-source');
      existing.dataset.parityCategoryFilterClone = 'true';
      existing.dataset.parityCategoryFilterSignature = sourceSignature;
      if (source.dataset.paritySearchCategoryFilterSource === 'true') {
        existing.dataset.paritySearchCategoryFilterClone = 'true';
      } else {
        delete existing.dataset.paritySearchCategoryFilterClone;
      }
      if (created) existing.dataset.parityCategoryFilterBound = 'false';
      insertCategoryFacet(target, existing);

      Array.from(target.querySelectorAll('[data-parity-category-filter-clone]')).forEach(function (candidate) {
        if (candidate !== existing) candidate.remove();
      });
    });
  }

  function syncCategoryFacets() {
    ensureSearchCategoryFacetSource();

    if (suppressCategoryFacetOnCurrentCollection()) {
      removeCollectionCategoryFacetSources();
      syncProductTypeV3Facets();
      return;
    }

    var source = getCategoryFacetSource();
    if (!source) {
      syncProductTypeV3Facets();
      return;
    }

    var target = primaryFacetTarget();

    if (target) {
      insertCategoryFacet(target, source);
    } else {
      bindCategoryFacet(source);
    }

    syncCategoryFacetDialogClone(source);
    syncProductTypeV3Facets();
  }

  function closestFilterRoot(node) {
    return node?.closest?.(filterRootSelector) || null;
  }

  function getFacetTitle(facet) {
    if (!facet) return null;

    return Array.from(facet.children).find(function (child) {
      return child.matches?.('.facettitle, [data-parity-category-filter-toggle]');
    }) || null;
  }

  function getFacetBody(facet, title) {
    if (!facet) return null;

    var body = facet.querySelector('[data-parity-category-filter-body]');
    if (body) return body;

    body = Array.from(facet.children).find(function (child) {
      return child !== title && child.matches?.('.facetbody');
    });
    if (body) return body;

    return Array.from(facet.children).find(function (child) {
      return child !== title;
    }) || null;
  }

  function isFacetBodyCollapsed(body) {
    if (!body) return true;
    if (body.hidden || body.classList.contains('collapsed')) return true;
    if (/^0(?:px)?$/i.test(String(body.style.height || '').trim())) return true;

    var style = window.getComputedStyle?.(body);
    return style?.display === 'none';
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function setClassIfChanged(element, className, enabled) {
    if (element.classList.contains(className) !== enabled) {
      element.classList.toggle(className, enabled);
    }
  }

  function setHiddenIfChanged(element, hidden) {
    if (element.hidden !== hidden) element.hidden = hidden;
  }

  function setInlineStyleIfChanged(element, property, value) {
    if (element.style[property] !== value) element.style[property] = value;
  }

  function removeInlineStyleIfPresent(element, property) {
    if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
  }

  function setFilterFacetExpanded(facet, expanded, animate) {
    var title = getFacetTitle(facet);
    var body = getFacetBody(facet, title);
    if (!title || !body) return;

    setAttributeIfChanged(title, 'aria-expanded', expanded ? 'true' : 'false');
    setClassIfChanged(facet, 'parity-cm-facet-expanded', expanded);
    setClassIfChanged(facet, 'parity-cm-facet-collapsed', !expanded);
    setFacetBodyExpanded(body, expanded, Boolean(animate));
  }

  function shouldDefaultDesktopCategoryFacet(facet, root) {
    if (!root || !root.matches?.(productRootSelector)) return false;
    if (facet.closest?.('#cm_FacetDialog, .FacetDialog')) return false;
    if (isMobileFilterCueViewport()) return false;
    if (facet.dataset.parityCmFacetDefaulted === 'true') return false;

    return hasFilterCueCategory(root);
  }

  function isProductTypeV3Facet(facet) {
    if (!facet || facet.closest?.('#cm_FacetDialog, .FacetDialog, .parity-cm-active-filters')) return false;

    return facet.matches?.('[data-parity-product-type-v3-filter-source], [data-parity-product-type-v3-filter-clone], .parity-cm-product-type-v3-facet');
  }

  function isDefaultOpenFilterFacet(facet) {
    return isCategoryCueFacet(facet) || isProductTypeV3Facet(facet);
  }

  function normalizeFilterFacet(facet) {
    if (facet?.closest?.('.parity-cm-active-filters')) return;

    var title = getFacetTitle(facet);
    var body = getFacetBody(facet, title);
    var root = closestFilterRoot(facet);
    if (!title || !body || !root) return;

    facet.dataset.parityCmFacet = 'true';
    title.dataset.parityCmFacetToggle = 'true';
    body.dataset.parityCmFacetBody = 'true';
    if (body.dataset.parityCmAccordionAnimating === 'true') return;

    if (!/^(button|a)$/i.test(title.tagName) && !title.hasAttribute('role')) {
      title.setAttribute('role', 'button');
    }

    if (!title.hasAttribute('tabindex')) {
      title.tabIndex = 0;
    }

    var ariaExpanded = title.getAttribute('aria-expanded');
    var expanded = ariaExpanded === 'true' || (ariaExpanded !== 'false' && !isFacetBodyCollapsed(body));

    if (shouldDefaultDesktopCategoryFacet(facet, root)) {
      expanded = isDefaultOpenFilterFacet(facet);
      facet.dataset.parityCmFacetDefaulted = 'true';
    }

    setFilterFacetExpanded(facet, expanded, false);
  }

  function productTypeV3OptionLabelFromLink(link) {
    if (!link) return '';

    return clean(
      link.querySelector?.('.parity-cm-product-type-v3-facet__option-text')?.textContent
        || String(link.textContent || '').replace(/\s*\(\d+\)\s*$/, '')
    );
  }

  function productTypeV3ParsedFromRenderedOptionLabel(label) {
    var normalizedLabel = clean(label);
    if (!normalizedLabel) return null;

    var link = Array.from(document.querySelectorAll('.parity-cm-product-type-v3-facet__link')).find(function (candidate) {
      return productTypeV3OptionLabelFromLink(candidate) === normalizedLabel;
    });
    if (!link) return null;

    return parseProductTypeV3Token(link.dataset?.parityProductTypeV3Value || '');
  }

  function productTypeV3ParsedFromActiveFilterChip(chip) {
    if (!chip) return null;

    var link = chip.querySelector?.('.facetentrykey, a');
    var candidates = [
      chip.dataset?.parityProductTypeV3ChipToken || '',
      productTypeV3TokenFromHref(link?.getAttribute?.('href') || ''),
      link?.getAttribute?.('data-value') || '',
      chip.getAttribute?.('data-value') || '',
      link?.textContent || '',
      chip.textContent || '',
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      var parsed = parseProductTypeV3Token(candidates[index]);
      if (parsed) return parsed;
    }

    var label = clean((link?.textContent || chip.textContent || '').replace(/^\s*Product\s*:\s*/i, ''));
    if (label) {
      var matchedCurrentValue = convermaxCurrentFilterValues(productTypeV3FacetField).find(function (currentValue) {
        var parsed = parseProductTypeV3Token(currentValue);
        return parsed && clean(parsed.label) === label;
      });
      var matchedParsed = parseProductTypeV3Token(matchedCurrentValue);
      if (matchedParsed) return matchedParsed;

      matchedParsed = productTypeV3ParsedFromRenderedOptionLabel(label);
      if (matchedParsed) return matchedParsed;
    }

    return null;
  }

  function productTypeV3ActiveFilterSignature(parsed) {
    if (!parsed) return '';

    return 'product_type_v3:' + (parsed.slug || clean(parsed.label));
  }

  function activeFilterChipCount(chips) {
    var seenV3 = new Set();
    var count = 0;

    chips?.querySelectorAll?.('.cmTemplate_chip').forEach(function (chip) {
      var signature = chip.dataset.parityProductTypeV3ChipSignature
        || productTypeV3ActiveFilterSignature(productTypeV3ParsedFromActiveFilterChip(chip));
      if (signature) {
        if (seenV3.has(signature)) return;
        seenV3.add(signature);
      }
      count += 1;
    });

    return count;
  }

  function activeFilterChipFilterPart(chip) {
    var parsed = productTypeV3ParsedFromActiveFilterChip(chip);
    if (parsed?.token) {
      return {
        field: productTypeV3FacetField,
        value: parsed.token,
      };
    }

    var field = activeFilterChipSurfaceField(chip);
    var value = activeFilterChipSurfaceValue(chip);
    if (!field || !value) return null;

    return {
      field: field,
      value: value,
    };
  }

  function activeFilterChipPartsFromRoot(root) {
    return Array.from(root?.querySelectorAll?.('.cmTemplate_chip') || [])
      .filter(function (chip) { return !chip.hidden; })
      .map(activeFilterChipFilterPart)
      .filter(Boolean);
  }

  function rememberActiveFilterChipParts(chips) {
    var parts = activeFilterChipPartsFromRoot(chips);

    if (parts.length) lastActiveFilterChipParts = parts;
  }

  function isActiveFilterChipSource(chips) {
    if (!chips || !activeFilterChipCount(chips)) return false;
    if (chips.closest('#cm_FacetDialog, .FacetDialog')) return false;
    if (chips.closest('#cm-garage, #cm-mobile-garage, .cm_garageDropdown')) return false;

    return true;
  }

  function findDesktopActiveFilterChips(root) {
    if (!root) return null;

    var preferred = root.querySelector('.cm_FacetPanel > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips');
    if (isActiveFilterChipSource(preferred)) return preferred;

    var raw = Array.from(root.querySelectorAll('.cm_FilterChips, .cm_filterChips')).find(function (chips) {
      return isActiveFilterChipSource(chips) && !chips.closest('.parity-cm-active-filters');
    });
    if (raw) return raw;

    var hosted = root.querySelector('.parity-cm-active-filters--desktop > .cm_FilterChips, .parity-cm-active-filters--desktop > .cm_filterChips');
    return isActiveFilterChipSource(hosted) ? hosted : null;
  }

  function activeFilterCountForRoot(root) {
    if (!root) return 0;

    var count = 0;
    var candidates = [
      root.querySelector('.parity-cm-active-filters--desktop > .cm_FilterChips, .parity-cm-active-filters--desktop > .cm_filterChips'),
      root.querySelector('.cm_FacetPanel > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips'),
    ];

    root.querySelectorAll?.('.cm_FilterChips, .cm_filterChips').forEach(function (chips) {
      if (!chips.closest('#cm_FacetDialog, .FacetDialog')) candidates.push(chips);
    });

    candidates.forEach(function (chips) {
      count = Math.max(count, activeFilterChipCount(chips));
    });

    return count;
  }

  function syncFilterDialogButtonLabels(root) {
    var scope = root || document;
    var roots = new Set();

    if (scope.matches?.(productRootSelector)) roots.add(scope);
    scope.querySelectorAll?.(productRootSelector).forEach(function (node) {
      roots.add(node);
    });

    roots.forEach(function (root) {
      var count = activeFilterCountForRoot(root);
      var label = count > 0 ? 'Filters (' + count + ')' : 'Filters';

      root.querySelectorAll('.cm_SearchHeader .cm_facetDialogButton').forEach(function (holder) {
        var button = holder.querySelector('.cm_dialogButton') || holder;
        button.querySelectorAll('.cm_icon, svg').forEach(function (icon) {
          icon.remove();
        });
        button.textContent = label;
        button.setAttribute('aria-label', label);
        button.dataset.parityCmFilterCount = String(count);
        holder.dataset.parityCmFilterCount = String(count);
      });
    });
  }

  function resetActiveProductTypeV3Chip(chip) {
    chip.hidden = false;
    chip.removeAttribute('aria-hidden');
    chip.style.removeProperty('display');
    delete chip.dataset.parityProductTypeV3ChipSignature;
    delete chip.dataset.parityProductTypeV3ChipDuplicate;
    delete chip.dataset.parityProductTypeV3ChipPrimary;
    delete chip.dataset.parityProductTypeV3ChipLabel;
  }

  function activeProductTypeV3ChipRemoveControl(chip) {
    return chip?.querySelector?.('.facetentryval') || null;
  }

  function removeActiveProductTypeV3ChipGroupFromDom(chip, signature) {
    if (!chip || !signature) return;

    var chips = chip.closest?.('.cm_FilterChips, .cm_filterChips') || chip.closest?.('.parity-cm-active-filters');
    Array.from(chips?.querySelectorAll?.('.cmTemplate_chip') || []).forEach(function (candidate) {
      if (candidate.dataset.parityProductTypeV3ChipSignature === signature) candidate.remove();
    });

    if (chips && !activeFilterChipCount(chips)) {
      removeActiveFilterHost(
        chips.closest?.('.parity-cm-active-filters'),
        chips.closest?.(productRootSelector) || chips.closest?.('#cm_FacetDialog, .FacetDialog') || document
      );
    }
    syncFilterDialogButtonLabels(document);
  }

  function normalizeActiveProductTypeV3ChipLabel(chip, parsed) {
    var link = chip?.querySelector?.('.facetentrykey, a');
    if (!link || !parsed?.label) return;

    var label = decodeUserSurfaceText(parsed.label, { decodePlusAsSpace: true });
    link.textContent = label;
    link.setAttribute('aria-label', label);
    chip.setAttribute('aria-label', label);
  }

  function normalizeActiveProductTypeV3Chips(chips) {
    if (!chips) return;

    var groups = new Map();

    chips.querySelectorAll('.cmTemplate_chip').forEach(function (chip) {
      resetActiveProductTypeV3Chip(chip);

      var parsed = productTypeV3ParsedFromActiveFilterChip(chip);
      var signature = productTypeV3ActiveFilterSignature(parsed);
      if (!signature) return;

      normalizeActiveProductTypeV3ChipLabel(chip, parsed);
      chip.dataset.parityProductTypeV3ChipToken = parsed.token;
      chip.dataset.parityProductTypeV3ChipSignature = signature;
      chip.dataset.parityProductTypeV3ChipLabel = parsed.label;

      if (!groups.has(signature)) groups.set(signature, []);
      groups.get(signature).push(chip);
    });

    groups.forEach(function (group) {
      group.forEach(function (chip, index) {
        if (index === 0) {
          chip.dataset.parityProductTypeV3ChipPrimary = 'true';
          return;
        }

        chip.dataset.parityProductTypeV3ChipDuplicate = 'true';
        chip.hidden = true;
        chip.setAttribute('aria-hidden', 'true');
        chip.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function activeFilterClearAllButtons(chips) {
    return Array.from(chips?.querySelectorAll?.('.cm_filter-chips_button, [data-cm-role="start-over"], [data-parity-cm-clear-all]') || []);
  }

  function bindActiveFilterClearAllButton(button) {
    if (!button || button.dataset.parityCmClearAllBound === 'true') return;

    button.dataset.parityCmClearAllBound = 'true';
    button.addEventListener('pointerdown', handleActiveFilterClearAllPointerDown, true);
    button.addEventListener('click', handleActiveFilterClearAllClick, true);
  }

  function activeFilterChipContainersFromHost(host) {
    return Array.from(host?.children || []).filter(function (child) {
      return child.matches?.('.cm_FilterChips, .cm_filterChips');
    });
  }

  function rememberActiveFilterChipPlacement(chips) {
    if (!chips || !chips.parentElement) return;
    if (chips.parentElement.closest?.('.parity-cm-active-filters')) return;

    var placement = activeFilterChipPlacements.get(chips);
    if (placement?.parent?.isConnected) return;

    activeFilterChipPlacements.set(chips, {
      parent: chips.parentElement,
      nextSibling: chips.nextSibling,
    });
  }

  function activeFilterRestoreRoot(host, root) {
    return root
      || host?.closest?.(productRootSelector)
      || host?.closest?.('#cm_FacetDialog, .FacetDialog')
      || document;
  }

  function fallbackActiveFilterChipParent(root, chips) {
    var scope = root || document;

    if (scope.matches?.('#cm_FacetDialog, .FacetDialog')) {
      return scope.querySelector('.dialog-body > .cm_FacetPanel, .dialog-body, .cm_FacetPanel') || scope;
    }

    var productRoot = scope.matches?.(productRootSelector)
      ? scope
      : scope.querySelector?.(productRootSelector) || chips?.closest?.(productRootSelector);

    return productRoot?.querySelector?.('.cm_FacetPanel')
      || productRoot?.querySelector?.('.cm_SearchResult, .cm_SearchResults, .itemsBlock')
      || productRoot
      || null;
  }

  function restoredActiveFilterChipAnchor(parent) {
    if (!parent?.matches?.('.cm_FacetPanel')) return null;

    return parent.querySelector?.(':scope > .cm_Facets, :scope > .cm_facets, :scope > .cmRepeater_facets') || null;
  }

  function removeInactiveActiveFilterControls(chips) {
    if (!chips || activeFilterChipCount(chips)) return;

    activeFilterClearAllButtons(chips).forEach(function (button) {
      button.remove();
    });
  }

  function emptyActiveFilterChips(chips) {
    chips?.querySelectorAll?.('.cmTemplate_chip').forEach(function (chip) {
      chip.remove();
    });
    activeFilterClearAllButtons(chips).forEach(function (button) {
      button.remove();
    });
  }

  function restoreActiveFilterChipContainer(chips, root) {
    if (!chips) return;

    removeInactiveActiveFilterControls(chips);

    var placement = activeFilterChipPlacements.get(chips);
    var parent = placement?.parent?.isConnected && !placement.parent.closest?.('.parity-cm-active-filters')
      ? placement.parent
      : fallbackActiveFilterChipParent(root, chips);

    if (!parent || chips.parentElement === parent) return;

    var nextSibling = placement?.nextSibling;
    if (nextSibling && nextSibling.parentElement === parent) {
      parent.insertBefore(chips, nextSibling);
      return;
    }

    var anchor = restoredActiveFilterChipAnchor(parent);
    if (anchor && anchor !== chips) {
      parent.insertBefore(chips, anchor);
      return;
    }

    parent.appendChild(chips);
  }

  function removeActiveFilterHost(host, root) {
    if (!host) return;

    var restoreRoot = activeFilterRestoreRoot(host, root);
    activeFilterChipContainersFromHost(host).forEach(function (chips) {
      restoreActiveFilterChipContainer(chips, restoreRoot);
    });
    host.remove();
  }

  function ensureActiveFilterClearAll(chips) {
    if (!chips || !activeFilterChipCount(chips)) return;

    var buttons = activeFilterClearAllButtons(chips);
    if (!buttons.length) {
      var target = chips.querySelector('.facetbody') || chips;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cm_filter-chips_button';
      button.dataset.parityCmClearAll = 'true';
      button.textContent = 'Clear All';
      target.appendChild(button);
      buttons.push(button);
    }

    buttons.forEach(function (button) {
      button.textContent = 'Clear All';
      button.classList.add('cm_filter-chips_button');
      bindActiveFilterClearAllButton(button);
    });
  }

  function prepareActiveFilterChips(chips) {
    if (!chips) return;

    chips.classList.add('parity-cm-active-filter-chips');
    normalizeActiveProductTypeV3Chips(chips);
    rememberActiveFilterChipParts(chips);

    chips.querySelectorAll('.facetholder').forEach(function (facet) {
      facet.classList.add('parity-cm-active-filter-facet');
      facet.classList.add('parity-cm-facet-expanded');
      facet.classList.remove('parity-cm-facet-collapsed');
    });

    chips.querySelectorAll('.facettitle').forEach(function (title) {
      title.setAttribute('aria-hidden', 'true');
      title.setAttribute('aria-expanded', 'true');
      title.tabIndex = -1;
    });

    chips.querySelectorAll('.facetbody').forEach(function (body) {
      body.hidden = false;
      body.classList.remove('collapsed');
      body.style.removeProperty('height');
      body.style.removeProperty('overflow');
      body.style.removeProperty('position');
      body.style.transition = 'none';
      body.style.animation = 'none';
    });

    chips.querySelectorAll('.cmTemplate_chip').forEach(function (chip) {
      chip.dataset.parityCmActiveFilterChip = 'true';
    });

    ensureActiveFilterClearAll(chips);
  }

  function normalizeEncodedTextNodes(node) {
    if (!node || !document.createTreeWalker) return;

    var walker = document.createTreeWalker(node, window.NodeFilter?.SHOW_TEXT || 4);
    var textNode = walker.nextNode();

    while (textNode) {
      var text = textNode.nodeValue || '';
      if (/%[0-9a-f]{2}|&(?:amp|#38|#x26);/i.test(text)) {
        var decoded = decodeUserSurfaceText(text, { preserveWhitespace: true });
        if (decoded !== text) textNode.nodeValue = decoded;
      }
      textNode = walker.nextNode();
    }
  }

  function normalizeEncodedUserSurfaceText(root) {
    var scope = root || document;
    var selector = [
      '.facetentrykey',
      '.facetentryval',
      '.cm_facet-value-name',
      '.cm_filter-chips_button',
      '.parity-cm-category-facet__link',
      '.parity-cm-product-type-v3-facet__group-title',
      '.parity-cm-product-type-v3-facet__option-text',
      'option',
    ].join(',');
    var nodes = [];

    if (scope.matches?.(selector)) nodes.push(scope);
    scope.querySelectorAll?.(selector).forEach(function (node) {
      nodes.push(node);
    });

    nodes.forEach(function (node) {
      normalizeEncodedTextNodes(node);

      ['aria-label', 'title'].forEach(function (attribute) {
        var value = node.getAttribute?.(attribute);
        if (!value || !/%[0-9a-f]{2}|&(?:amp|#38|#x26);/i.test(value)) return;

        node.setAttribute(attribute, decodeUserSurfaceText(value));
      });
    });
  }

  function ensureActiveFilterHost(parent, className, anchor, insertAfter) {
    if (!parent) return null;

    var host = parent.querySelector('.' + className);
    if (!host) {
      host = document.createElement('div');
      host.className = 'parity-cm-active-filters ' + className;
    }

    if (anchor) {
      if (insertAfter) {
        anchor.insertAdjacentElement('afterend', host);
      } else {
        parent.insertBefore(host, anchor);
      }
    } else if (host.parentElement !== parent) {
      parent.appendChild(host);
    }

    return host;
  }

  function moveActiveFilterChips(host, chips) {
    if (!host || !chips) return;

    Array.from(host.children).forEach(function (child) {
      if (child === chips) return;
      if (child.matches?.('.cm_FilterChips, .cm_filterChips')) {
        restoreActiveFilterChipContainer(child, activeFilterRestoreRoot(host));
      } else {
        child.remove();
      }
    });

    prepareActiveFilterChips(chips);
    if (chips.parentElement !== host) {
      rememberActiveFilterChipPlacement(chips);
      host.appendChild(chips);
    }
  }

  function syncDesktopActiveFilterChips(root) {
    if (!root || root.closest?.('#cm_FacetDialog, .FacetDialog')) return;

    var searchHeader = root.querySelector('.cm_SearchHeader');
    var anchor = searchHeader || root.firstElementChild;
    var source = findDesktopActiveFilterChips(root);
    var host = root.querySelector('.parity-cm-active-filters--desktop');

    if (!source || !activeFilterChipCount(source) || !anchor) {
      if (host) removeActiveFilterHost(host, root);
      return;
    }

    host = ensureActiveFilterHost(root, 'parity-cm-active-filters--desktop', anchor, Boolean(searchHeader));
    moveActiveFilterChips(host, source);
  }

  function syncMobileActiveFilterChips(dialog) {
    if (!dialog || !dialog.matches?.('#cm_FacetDialog, .FacetDialog')) return;

    var header = dialog.querySelector('.dialog-header');
    var buttons = header?.querySelector?.('.buttons-container');
    var source = dialog.querySelector('.dialog-body > .cm_filterChips, .dialog-body > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips, .cm_FacetPanel > .cm_FilterChips')
      || header?.querySelector?.(':scope > .parity-cm-active-filters--mobile > .cm_filterChips, :scope > .parity-cm-active-filters--mobile > .cm_FilterChips');
    var host = header?.querySelector?.(':scope > .parity-cm-active-filters--mobile');

    if (!source || !activeFilterChipCount(source) || !header) {
      if (host) removeActiveFilterHost(host, dialog);
      return;
    }

    host = ensureActiveFilterHost(header, 'parity-cm-active-filters--mobile', buttons, false);
    moveActiveFilterChips(host, source);
  }

  function syncActiveFilterChips(root) {
    var scope = root || document;
    var roots = new Set();
    var dialogs = new Set();

    if (scope.matches?.(productRootSelector)) roots.add(scope);
    if (scope.matches?.('#cm_FacetDialog, .FacetDialog')) dialogs.add(scope);

    scope.querySelectorAll?.(productRootSelector).forEach(function (node) {
      roots.add(node);
    });
    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(function (node) {
      dialogs.add(node);
    });

    roots.forEach(syncDesktopActiveFilterChips);
    dialogs.forEach(syncMobileActiveFilterChips);
  }

  function normalizeFilterFacets(root) {
    var scope = root || document;
    var facets = [];

    if (scope.matches?.('.facetholder')) facets.push(scope);
    scope.querySelectorAll?.('.facetholder').forEach(function (facet) {
      facets.push(facet);
    });

    facets.forEach(normalizeFilterFacet);
  }

  function collectProductRoots(scope) {
    var roots = new Set();

    if (scope?.matches?.(productRootSelector)) roots.add(scope);
    scope?.querySelectorAll?.(productRootSelector).forEach(function (node) {
      roots.add(node);
    });

    return roots;
  }

  function parseResultCount(value) {
    var text = String(value || '').replace(/\u00a0/g, ' ');
    var match = text.match(/\d[\d,.\s]*/);
    if (!match) return null;

    var count = Number.parseInt(match[0].replace(/[^\d]/g, ''), 10);
    return Number.isFinite(count) ? count : null;
  }

  function resultCountForRoot(root) {
    if (!root) return null;

    var counts = [];
    root.querySelectorAll([
      '.cm_total-hits',
      '.total-hits',
      '[data-cm-role="total-hits"]',
      '[data-cm-total-hits]',
      '[data-total-hits]',
    ].join(',')).forEach(function (node) {
      [
        node.getAttribute('data-cm-total-hits'),
        node.getAttribute('data-total-hits'),
        node.textContent,
      ].forEach(function (value) {
        var count = parseResultCount(value);
        if (count !== null) counts.push(count);
      });
    });

    return counts.length ? Math.max.apply(Math, counts) : null;
  }

  function usableRect(node) {
    if (!node?.getBoundingClientRect) return null;

    var rect = node.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return null;

    var style = window.getComputedStyle?.(node);
    if (style?.display === 'none' || style?.visibility === 'hidden') return null;

    return rect;
  }

  function rectCenter(rect) {
    return {
      x: rect.left + rect.width / 2 + (window.scrollX || window.pageXOffset || 0),
      y: rect.top + rect.height / 2 + (window.scrollY || window.pageYOffset || 0),
    };
  }

  function visibleTextRect(node) {
    if (!node || !document.createRange) return null;

    try {
      var range = document.createRange();
      range.selectNodeContents(node);

      var rect = range.getBoundingClientRect();
      range.detach?.();

      if (rect.width > 0 && rect.height > 0) return rect;
    } catch (_error) {
      return null;
    }

    return null;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function filterCueTodayKey() {
    var now = new Date();
    return [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0'),
    ].join('-');
  }

  function filterCueUsesDailyGate() {
    var location = window.location;
    var hostname = String(location?.hostname || '').toLowerCase();

    if (!hostname || location?.protocol === 'file:') return false;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0' || hostname === '::1') return false;
    if (hostname.endsWith('.localhost')) return false;

    return true;
  }

  function filterCueSeenToday() {
    if (!filterCueUsesDailyGate()) return false;

    try {
      return window.localStorage?.getItem(filterCueSeenStorageKey) === filterCueTodayKey();
    } catch (_error) {
      return false;
    }
  }

  function markFilterCueSeenToday() {
    if (!filterCueUsesDailyGate()) return;

    try {
      window.localStorage?.setItem(filterCueSeenStorageKey, filterCueTodayKey());
    } catch (_error) {
      // Storage can be unavailable in private or embedded contexts; the cue remains one-shot per page.
    }
  }

  function claimFilterCueDailySlot() {
    if (!filterCueUsesDailyGate()) return true;
    if (filterCueDailyPending || filterCueSeenToday()) return false;

    filterCueDailyPending = true;
    return true;
  }

  function releaseFilterCueDailySlot() {
    filterCueDailyPending = false;
  }

  function isMobileFilterCueViewport() {
    return Boolean(window.matchMedia?.('(max-width: 767px)')?.matches);
  }

  function filterDialogButtonForRoot(root) {
    return root?.querySelector?.('.cm_SearchHeader .cm_facetDialogButton .cm_dialogButton, .cm_SearchHeader .cm_facetDialogButton') || null;
  }

  function titleTextForFacet(facet) {
    var title = getFacetTitle(facet);
    return clean(title?.textContent || facet?.getAttribute?.('aria-label') || '');
  }

  function isCueFacetCandidate(facet) {
    if (!facet || facet.closest?.('#cm_FacetDialog, .FacetDialog, .parity-cm-active-filters')) return false;
    return Boolean(usableRect(facet));
  }

  function isCategoryCueFacet(facet) {
    if (!facet || facet.closest?.('#cm_FacetDialog, .FacetDialog, .parity-cm-active-filters')) return false;
    if (facet.matches?.('[data-parity-category-filter-source], [data-parity-category-filter-clone], .parity-cm-category-facet')) return true;

    return /\bcategories?\b/.test(titleTextForFacet(facet));
  }

  function categoryCueFacetForRoot(root, requireVisible) {
    return Array.from(root.querySelectorAll([
      '[data-parity-category-filter-source]',
      '[data-parity-category-filter-clone]',
      '.parity-cm-category-facet',
      '.cm_FacetPanel:not(.dialog-body) .facetholder',
      '.cm_facets .facetholder',
    ].join(','))).find(function (facet) {
      if (!isCategoryCueFacet(facet)) return false;
      return !requireVisible || isCueFacetCandidate(facet);
    }) || null;
  }

  function hasFilterCueCategory(root) {
    return Boolean(categoryCueFacetForRoot(root, false));
  }

  function rectForCategoryText(title) {
    if (!title || !document.createRange || !document.createTreeWalker) return null;

    var walker = document.createTreeWalker(title, window.NodeFilter?.SHOW_TEXT || 4);
    var node = walker.nextNode();

    while (node) {
      var match = String(node.nodeValue || '').match(/\bcategories?\b/i);
      if (match) {
        var range = document.createRange();
        range.setStart(node, match.index);
        range.setEnd(node, match.index + match[0].length);

        var rect = range.getBoundingClientRect();
        range.detach?.();

        if (rect.width > 0 && rect.height > 0) return rect;
      }

      node = walker.nextNode();
    }

    return null;
  }

  function categoryCueTargetForFacet(facet) {
    var title = getFacetTitle(facet);
    if (!title) return rectCenter(usableRect(facet));

    var label = Array.from(title.querySelectorAll('.parity-cm-category-facet__title-main, span, strong, b')).find(function (node) {
      return /\bcategories?\b/i.test(node.textContent || '') && usableRect(node);
    });
    var labelRect = usableRect(label) || rectForCategoryText(title);
    if (labelRect) return rectCenter(labelRect);

    var titleRect = usableRect(title);
    if (titleRect) return rectCenter(titleRect);

    return rectCenter(usableRect(facet));
  }

  function findDesktopFilterCueTarget(root) {
    var categoryFacet = categoryCueFacetForRoot(root, true);
    if (categoryFacet) return categoryCueTargetForFacet(categoryFacet);

    return null;
  }

  function filterCueTargetForRoot(root) {
    var button = filterDialogButtonForRoot(root);
    var buttonRect = usableRect(button);

    if (!isMobileFilterCueViewport()) {
      var desktopTarget = findDesktopFilterCueTarget(root);
      if (desktopTarget) return desktopTarget;
    }

    if (buttonRect) return rectCenter(buttonRect);
    return null;
  }

  function filterCueHintPointForRoot(root, target) {
    var totalHits = Array.from(root.querySelectorAll('.cm_SearchHeader .cm_total-hits, .cm_total-hits, .total-hits'))
      .find(function (node) { return usableRect(node); });
    var anchor = totalHits || filterDialogButtonForRoot(root);
    var rect = usableRect(anchor);
    var point = rect ? rectCenter(rect) : target;
    var scrollX = window.scrollX || window.pageXOffset || 0;
    var scrollY = window.scrollY || window.pageYOffset || 0;

    if (rect && !isMobileFilterCueViewport()) {
      var desktopRect = totalHits ? visibleTextRect(totalHits) || rect : rect;
      point = {
        x: desktopRect.right + 12 + scrollX,
        y: desktopRect.top + desktopRect.height / 2 + scrollY,
        offsetX: '0px',
        offsetY: '-50%',
      };
    }

    if (isMobileFilterCueViewport() && rect) {
      point = {
        x: rect.left + rect.width / 2 + scrollX,
        y: rect.bottom + 18 + scrollY,
      };
    }

    return {
      x: clamp(point.x, scrollX + 120, scrollX + Math.max(120, window.innerWidth - 120)),
      y: clamp(point.y, scrollY + 24, scrollY + Math.max(24, window.innerHeight - 24)),
      offsetX: point.offsetX || '-50%',
      offsetY: point.offsetY || '-50%',
    };
  }

  function productGridForRoot(root) {
    return root?.querySelector?.([
      '.cm_SearchResult .cmRepeater_items',
      '.cm_SearchResults .cmRepeater_items',
      '.itemsBlock .cmRepeater_items',
      '.cmRepeater_items',
    ].join(',')) || null;
  }

  function firstTwoProductRows(root) {
    var grid = productGridForRoot(root);
    if (!grid) return [];

    var entries = Array.from(grid.children)
      .map(function (item, index) {
        var rect = usableRect(item);
        return rect ? { item: item, rect: rect, index: index } : null;
      })
      .filter(Boolean);
    if (!entries.length) return [];

    var rows = [];
    entries.forEach(function (entry) {
      var row = rows.find(function (candidate) {
        return Math.abs(candidate.top - entry.rect.top) <= 8;
      });

      if (!row) {
        row = { top: entry.rect.top, entries: [] };
        rows.push(row);
      }

      row.entries.push(entry);
    });

    return rows
      .sort(function (left, right) { return left.top - right.top; })
      .slice(0, 2)
      .flatMap(function (row) {
        return row.entries.sort(function (left, right) {
          return left.rect.left - right.rect.left || left.index - right.index;
        });
      })
      .map(function (entry) { return entry.item; });
  }

  function imageForProductItem(item) {
    return item?.querySelector?.('img[src], img[srcset], img[data-src], img[data-original], img[data-lazy-src]') || null;
  }

  function imageUrlForAverageColor(image) {
    if (!image) return '';

    return image.currentSrc
      || image.src
      || image.getAttribute('data-src')
      || image.getAttribute('data-original')
      || image.getAttribute('data-lazy-src')
      || '';
  }

  function averageColorFromImageUrl(url) {
    return new Promise(function (resolve) {
      if (!url || !window.Image || !document.createElement) {
        resolve(null);
        return;
      }

      var image = new Image();
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(null);
      }, 1200);

      function finish(color) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(color);
      }

      image.crossOrigin = 'anonymous';
      image.onload = function () {
        try {
          var width = Math.max(1, Math.min(24, image.naturalWidth || image.width || 1));
          var height = Math.max(1, Math.min(24, image.naturalHeight || image.height || 1));
          var canvas = document.createElement('canvas');
          var context = canvas.getContext?.('2d', { willReadFrequently: true });
          if (!context) {
            finish(null);
            return;
          }

          canvas.width = width;
          canvas.height = height;
          context.drawImage(image, 0, 0, width, height);

          var pixels = context.getImageData(0, 0, width, height).data;
          var color = averageColorFromPixels(pixels, true) || averageColorFromPixels(pixels, false);
          finish(color);
        } catch (_error) {
          finish(null);
        }
      };
      image.onerror = function () {
        finish(null);
      };
      image.src = url;

      if (image.complete && image.naturalWidth) image.onload();
    });
  }

  function averageColorFromPixels(pixels, skipLightPixels) {
    var red = 0;
    var green = 0;
    var blue = 0;
    var weight = 0;

    for (var index = 0; index < pixels.length; index += 4) {
      var alpha = pixels[index + 3];
      if (alpha < 24) continue;

      var currentRed = pixels[index];
      var currentGreen = pixels[index + 1];
      var currentBlue = pixels[index + 2];

      if (skipLightPixels && currentRed > 242 && currentGreen > 242 && currentBlue > 242) continue;

      red += currentRed * alpha;
      green += currentGreen * alpha;
      blue += currentBlue * alpha;
      weight += alpha;
    }

    if (!weight) return null;

    return 'rgb(' + [
      Math.round(red / weight),
      Math.round(green / weight),
      Math.round(blue / weight),
    ].join(', ') + ')';
  }

  function fallbackCueColor(root, index) {
    var style = window.getComputedStyle?.(root);
    return style?.getPropertyValue('--cm-garage-bg')?.trim()
      || style?.getPropertyValue('--color-sale-tag')?.trim()
      || filterCueFallbackColors[index % filterCueFallbackColors.length];
  }

  function averageCueColorForItem(item, root, index) {
    var directColor = item?.getAttribute?.('data-parity-cm-filter-cue-color');
    if (directColor) return Promise.resolve(directColor);

    var image = imageForProductItem(item);
    var imageColor = image?.getAttribute?.('data-parity-cm-filter-cue-color');
    if (imageColor) return Promise.resolve(imageColor);

    return averageColorFromImageUrl(imageUrlForAverageColor(image)).then(function (color) {
      return color || fallbackCueColor(root, index);
    });
  }

  function cueStartPointForItem(item) {
    var image = imageForProductItem(item);
    var imageRect = usableRect(image);
    var itemRect = usableRect(item);
    var rect = imageRect || itemRect;
    if (!rect) return null;

    return rectCenter(rect);
  }

  function buildFilterCueDots(root) {
    var items = firstTwoProductRows(root);

    return Promise.all(items.map(function (item, index) {
      var point = cueStartPointForItem(item);
      if (!point) return null;

      return averageCueColorForItem(item, root, index).then(function (color) {
        return {
          color: color,
          fromX: point.x - 6,
          fromY: point.y - 6,
          delay: Math.min(index * 45, 360),
        };
      });
    })).then(function (dots) {
      return dots.filter(Boolean);
    });
  }

  function removeFilterCue(root) {
    var state = filterCueStates.get(root);
    state?.overlay?.remove?.();
    if (state) {
      state.overlay = null;
      state.playing = false;
    }
  }

  function renderFilterCue(root, dots, target, hintPoint) {
    var overlay = document.createElement('div');
    var documentElement = document.documentElement;
    var body = document.body;
    var width = Math.max(
      documentElement?.scrollWidth || 0,
      body?.scrollWidth || 0,
      window.innerWidth || 0
    );
    var height = Math.max(
      documentElement?.scrollHeight || 0,
      body?.scrollHeight || 0,
      window.innerHeight || 0
    );

    overlay.className = 'parity-cm-filter-cue';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.width = width + 'px';
    overlay.style.height = height + 'px';
    overlay.style.setProperty('--parity-cm-filter-cue-target-x', Math.round(target.x) + 'px');
    overlay.style.setProperty('--parity-cm-filter-cue-target-y', Math.round(target.y) + 'px');
    overlay.style.setProperty('--parity-cm-filter-cue-hint-x', Math.round(hintPoint.x) + 'px');
    overlay.style.setProperty('--parity-cm-filter-cue-hint-y', Math.round(hintPoint.y) + 'px');
    overlay.style.setProperty('--parity-cm-filter-cue-hint-offset-x', hintPoint.offsetX || '-50%');
    overlay.style.setProperty('--parity-cm-filter-cue-hint-offset-y', hintPoint.offsetY || '-50%');

    var hint = document.createElement('div');
    hint.className = 'parity-cm-filter-cue__hint';
    hint.textContent = 'Too many to scan manually';
    overlay.appendChild(hint);

    dots.forEach(function (dot) {
      var dotElement = document.createElement('span');
      dotElement.className = 'parity-cm-filter-cue__dot';
      dotElement.style.setProperty('--parity-cm-filter-cue-dot-color', dot.color);
      dotElement.style.setProperty('--parity-cm-filter-cue-from-x', Math.round(dot.fromX) + 'px');
      dotElement.style.setProperty('--parity-cm-filter-cue-from-y', Math.round(dot.fromY) + 'px');
      dotElement.style.setProperty('--parity-cm-filter-cue-to-x', Math.round(target.x - 6) + 'px');
      dotElement.style.setProperty('--parity-cm-filter-cue-to-y', Math.round(target.y - 6) + 'px');
      dotElement.style.setProperty('--parity-cm-filter-cue-delay', dot.delay + 'ms');
      overlay.appendChild(dotElement);
    });

    var targetPulse = document.createElement('span');
    targetPulse.className = 'parity-cm-filter-cue__target';
    overlay.appendChild(targetPulse);

    document.body.appendChild(overlay);
    return overlay;
  }

  function syncFilterCueForRoot(root) {
    if (!root || root.closest?.('#cm_FacetDialog, .FacetDialog')) return;

    var count = resultCountForRoot(root);
    var state = filterCueStates.get(root) || {};

    if (count === null || count <= filterCueThreshold || !hasFilterCueCategory(root)) {
      removeFilterCue(root);
      filterCueStates.delete(root);
      root.classList.remove('parity-cm-filter-cue-eligible');
      return;
    }

    if (filterCueSeenToday() && !state.overlay && !state.playing) {
      removeFilterCue(root);
      root.classList.remove('parity-cm-filter-cue-eligible');
      return;
    }

    root.classList.add('parity-cm-filter-cue-eligible');

    if (state.played || state.playing) return;

    var target = filterCueTargetForRoot(root);
    if (!target) return;
    if (!claimFilterCueDailySlot()) return;

    var token = {};
    state.playing = true;
    state.token = token;
    filterCueStates.set(root, state);

    buildFilterCueDots(root).then(function (dots) {
      var currentState = filterCueStates.get(root);
      if (!currentState || currentState.token !== token) {
        releaseFilterCueDailySlot();
        return;
      }
      if (!root.isConnected || resultCountForRoot(root) <= filterCueThreshold || !hasFilterCueCategory(root)) {
        filterCueStates.delete(root);
        releaseFilterCueDailySlot();
        return;
      }

      currentState.played = true;
      currentState.overlay?.remove?.();
      currentState.overlay = renderFilterCue(root, dots, target, filterCueHintPointForRoot(root, target));
      markFilterCueSeenToday();
      releaseFilterCueDailySlot();
      filterCueStates.set(root, currentState);

      window.setTimeout(function () {
        var latestState = filterCueStates.get(root);
        if (!latestState || latestState.token !== token) return;

        latestState.overlay?.remove?.();
        latestState.overlay = null;
        latestState.playing = false;
        filterCueStates.set(root, latestState);
      }, filterCueDuration);
    });
  }

  function syncFilterCues(root) {
    collectProductRoots(root || document).forEach(syncFilterCueForRoot);
  }

  function isFilterDialogClosed(dialog) {
    if (!dialog || !dialog.isConnected) return true;
    if (dialog.hidden || dialog.getAttribute('aria-hidden') === 'true') return true;
    if (dialog.classList.contains('hidden') || dialog.classList.contains('is-hidden')) return true;
    if (/^none$/i.test(String(dialog.style?.display || '').trim())) return true;

    return false;
  }

  function releaseFilterDialogOverlay(dialog) {
    if (!dialog) return;
    dialog.classList.remove('parity-cm-filter-dialog');
  }

  function forceFilterDialogClosed(dialog) {
    if (!dialog || !dialog.isConnected) return;
    dialog.dataset.parityCmForcedClosed = 'true';
    dialog.style.display = 'none';
    dialog.setAttribute('aria-hidden', 'true');
    releaseFilterDialogOverlay(dialog);
  }

  function releaseClosedFilterDialogOverlay(dialog) {
    if (isFilterDialogClosed(dialog)) releaseFilterDialogOverlay(dialog);
  }

  function scheduleFilterDialogRelease(dialog, force) {
    window.setTimeout(function () {
      if (force && isFilterDialogClosed(dialog)) dialog.dataset.parityCmForcedClosed = 'true';
      releaseClosedFilterDialogOverlay(dialog);
    }, 0);
    window.setTimeout(function () {
      if (isFilterDialogClosed(dialog)) {
        if (force) dialog.dataset.parityCmForcedClosed = 'true';
        releaseFilterDialogOverlay(dialog);
      } else if (force) {
        forceFilterDialogClosed(dialog);
      }
    }, 120);
  }

  function requestFilterDialogClose(dialog) {
    if (!dialog) return;

    var doneButton = dialog.querySelector('.cm_facet-dialog_button-done');
    if (doneButton) {
      dialog.dataset.parityCmForcedClosed = 'true';
      doneButton.click();
    } else {
      forceFilterDialogClosed(dialog);
    }

    scheduleFilterDialogRelease(dialog, true);
  }

  function normalizeFilterDialog(dialog) {
    if (!dialog || !dialog.matches?.('#cm_FacetDialog, .FacetDialog')) return;
    if (!dialog.querySelector('.dialog-container')) return;

    if (isFilterDialogClosed(dialog)) {
      releaseFilterDialogOverlay(dialog);
      return;
    }

    dialog.classList.add('parity-cm-filter-dialog');

    var title = dialog.querySelector('.dialog-title');
    if (title) title.textContent = 'Filter';

    var clear = dialog.querySelector('.cm_facet-dialog_button-clear span, .cm_facet-dialog_button-clear');
    if (clear) clear.textContent = 'Clear All';

    var done = dialog.querySelector('.cm_facet-dialog_button-done span, .cm_facet-dialog_button-done');
    if (done) done.textContent = 'Apply';

    var doneButton = dialog.querySelector('.cm_facet-dialog_button-done');
    if (doneButton && !doneButton.dataset.parityCmFilterCloseBound) {
      doneButton.dataset.parityCmFilterCloseBound = 'true';
      doneButton.addEventListener('click', function () {
        dialog.dataset.parityCmForcedClosed = 'true';
        scheduleFilterDialogRelease(dialog, true);
      });
    }

    if (!dialog.dataset.parityCmBackdropCloseBound) {
      dialog.dataset.parityCmBackdropCloseBound = 'true';
      dialog.addEventListener('click', function (event) {
        if (event.target?.closest?.('.dialog-content')) return;
        if (!dialog.classList.contains('parity-cm-filter-dialog')) return;

        event.preventDefault();
        requestFilterDialogClose(dialog);
      });
    }

    var header = dialog.querySelector('.dialog-header');
    if (!header || header.querySelector('.parity-cm-filter-close')) return;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'parity-cm-filter-close';
    close.setAttribute('aria-label', 'Close filters');
    close.addEventListener('click', function (event) {
      event.preventDefault();
      requestFilterDialogClose(dialog);
    });
    header.appendChild(close);
  }

  function normalizeFilterChrome(root) {
    normalizeConvermaxLocationQuery();
    syncActiveFilterChips(root || document);
    clearUrlFiltersAfterNativeActiveFilterClearAll();
    normalizeEncodedUserSurfaceText(root || document);
    syncFilterDialogButtonLabels(root || document);
    normalizeFilterFacets(root || document);
    syncFilterCues(root || document);

    var scope = root || document;
    if (scope.matches?.('#cm_FacetDialog, .FacetDialog')) normalizeFilterDialog(scope);
    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(normalizeFilterDialog);
  }

  function handleFilterFacetToggle(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target?.closest?.('.parity-cm-category-facet__shop-all')) return;

    var title = event.target?.closest?.('[data-parity-cm-facet-toggle], .facettitle, [data-parity-category-filter-toggle]');
    var facet = title?.closest?.('.facetholder');
    if (!title || !facet || !closestFilterRoot(facet)) return;

    var body = getFacetBody(facet, title);
    if (!body) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setFilterFacetExpanded(facet, title.getAttribute('aria-expanded') !== 'true', true);
  }

  function reopenForcedFilterDialog(dialog) {
    if (!dialog || dialog.dataset.parityCmForcedClosed !== 'true') return false;

    delete dialog.dataset.parityCmForcedClosed;
    dialog.hidden = false;
    dialog.classList.remove('hidden', 'is-hidden');
    dialog.style.removeProperty('display');
    dialog.removeAttribute('aria-hidden');
    normalizeFilterDialog(dialog);
    return true;
  }

  function reopenForcedFilterDialogs(root) {
    var scope = root || document;
    var reopened = false;

    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(function (dialog) {
      reopened = reopenForcedFilterDialog(dialog) || reopened;
    });

    return reopened;
  }

  function handleFilterDialogOpen(event) {
    if (!event.target?.closest?.('.cm_SearchHeader .cm_facetDialogButton, .cm_SearchHeader .cm_dialogButton')) return;

    window.setTimeout(function () {
      if (reopenForcedFilterDialogs(document)) normalizeFilterChrome(document);
    }, 0);
    window.setTimeout(function () {
      if (reopenForcedFilterDialogs(document)) normalizeFilterChrome(document);
    }, 120);
  }

  function activeFilterChipFromEvent(event) {
    var chip = event.target?.closest?.('.cmTemplate_chip');
    if (!chip) return null;
    if (chip.closest('.parity-cm-active-filters')) return chip;

    var chips = chip.closest('.cm_FilterChips, .cm_filterChips');
    if (!chips) return null;
    if (chips.closest('#cm-garage, #cm-mobile-garage, .cm_garageDropdown')) return null;

    return chip;
  }

  function removeActiveProductTypeV3ChipGroup(chip) {
    var signature = chip?.dataset?.parityProductTypeV3ChipSignature || '';
    if (!signature || removingGroupedActiveFilterChips) return false;
    if (removeProductTypeV3FilterSignature(signature)) {
      removeActiveProductTypeV3ChipGroupFromDom(chip, signature);
      return true;
    }

    var chips = chip.closest?.('.cm_FilterChips, .cm_filterChips') || chip.closest?.('.parity-cm-active-filters');
    var groupedChips = Array.from(chips?.querySelectorAll?.('.cmTemplate_chip') || []).filter(function (candidate) {
      return candidate.dataset.parityProductTypeV3ChipSignature === signature;
    });
    if (groupedChips.length <= 1) return false;

    var removes = groupedChips.map(activeProductTypeV3ChipRemoveControl).filter(Boolean);
    if (!removes.length) return false;

    removingGroupedActiveFilterChips = true;
    try {
      removes.forEach(function (remove) {
        remove.click();
      });
    } finally {
      removingGroupedActiveFilterChips = false;
    }

    return true;
  }

  function removeAllActiveFilterHosts() {
    document.querySelectorAll('.parity-cm-active-filters').forEach(function (host) {
      activeFilterChipContainersFromHost(host).forEach(emptyActiveFilterChips);
      removeActiveFilterHost(
        host,
        host.closest?.(productRootSelector) || host.closest?.('#cm_FacetDialog, .FacetDialog') || document
      );
    });
    syncFilterDialogButtonLabels(document);
  }

  function clearAllConvermaxFilterUrl() {
    var preservedParams = convermaxPreservedQueryParams(window.location.search || '');
    var nextUrl = String(window.location.pathname || '/')
      + (preservedParams.length ? '?' + preservedParams.join('&') : '')
      + String(window.location.hash || '');
    var currentUrl = String(window.location.pathname || '/') + String(window.location.search || '') + String(window.location.hash || '');
    if (nextUrl === currentUrl) return false;

    window.history?.pushState?.(window.history.state, document.title, nextUrl);
    dispatchConvermaxPopState();
    scheduleProductTypeV3FilterRefreshes();
    return true;
  }

  function clearAllConvermaxFilters() {
    if (!clearAllConvermaxFilterUrl()) return false;

    removeAllActiveFilterHosts();
    return true;
  }

  function activeFilterChipSurfaceValue(chip) {
    var link = chip?.querySelector?.('.facetentrykey, a');
    var text = decodeUserSurfaceText(link?.textContent || chip?.textContent || '', { decodePlusAsSpace: true })
      .replace(/\s+/g, ' ')
      .trim();

    return text.replace(/^[^:]{1,60}:\s*/, '').trim();
  }

  function activeFilterChipSurfaceField(chip) {
    var label = clean(chip?.querySelector?.('.cm_chip-name')?.textContent || '');
    if (!label) return '';

    if (label.indexOf('brand') !== -1) return 'custom_brand';
    if (label.indexOf('product type') !== -1) return 'custom_product_type_v2';
    if (label === 'product') return productTypeV3FacetField;

    return '';
  }

  function activeFilterPartValue(part) {
    return decodeUserSurfaceText(part?.value || '', { decodePlusAsSpace: true });
  }

  function removeActiveFilterChipFromDom(chip) {
    if (!chip) return;

    var chips = chip.closest?.('.cm_FilterChips, .cm_filterChips') || chip.closest?.('.parity-cm-active-filters');
    chip.remove();

    if (chips && !activeFilterChipCount(chips)) {
      removeActiveFilterHost(
        chips.closest?.('.parity-cm-active-filters'),
        chips.closest?.(productRootSelector) || chips.closest?.('#cm_FacetDialog, .FacetDialog') || document
      );
    }

    syncFilterDialogButtonLabels(document);
  }

  function removeConvermaxFilterForActiveChip(chip) {
    var chipValue = clean(activeFilterChipSurfaceValue(chip));
    if (!chipValue) return false;

    var chipField = activeFilterChipSurfaceField(chip);
    var removed = false;
    var nextParts = [];
    convermaxCurrentQueryParts().forEach(function (part) {
      var fieldMatches = !chipField || part.field === chipField;
      if (fieldMatches && clean(activeFilterPartValue(part)) === chipValue) {
        removed = true;
        return;
      }

      nextParts.push(part);
    });

    if (!removed) return false;

    var currentSearch = window.location.search || '';
    var query = buildConvermaxLocationQuery(nextParts, {
      preserveCurrentQuery: true,
      useFacetParam: searchUsesConvermaxFacetParam(currentSearch) || convermaxPreservedQueryParams(currentSearch).length > 0,
    });
    var nextPath = String(window.location.pathname || '/')
      + (query ? '?' + query : '')
      + String(window.location.hash || '');
    var currentPath = String(window.location.pathname || '/')
      + String(window.location.search || '')
      + String(window.location.hash || '');
    if (nextPath === currentPath) return false;

    window.history?.pushState?.(window.history.state, document.title, nextPath);
    dispatchConvermaxPopState();
    removeActiveFilterChipFromDom(chip);
    scheduleProductTypeV3FilterRefreshes();
    return true;
  }

  function activeFilterPartMatchesRememberedChip(part, remembered) {
    if (!part || !remembered || part.field !== remembered.field) return false;

    if (part.field === productTypeV3FacetField) {
      return productTypeV3ActiveFilterSignature(parseProductTypeV3Token(part.value))
        === productTypeV3ActiveFilterSignature(parseProductTypeV3Token(remembered.value));
    }

    return clean(activeFilterPartValue(part))
      === clean(decodeUserSurfaceText(remembered.value || '', { decodePlusAsSpace: true }));
  }

  function clearConvermaxUrlFilterParts(parts) {
    var filters = (parts || []).filter(Boolean);
    if (!filters.length) return false;

    var currentParts = convermaxQueryPartsFromSearch(window.location.search || '');
    if (!currentParts.length) return false;

    var removed = false;
    var nextParts = currentParts.filter(function (part) {
      var matches = filters.some(function (remembered) {
        return activeFilterPartMatchesRememberedChip(part, remembered);
      });

      if (matches) removed = true;
      return !matches;
    });

    if (!removed) return false;

    var currentSearch = window.location.search || '';
    var query = buildConvermaxLocationQuery(nextParts, {
      preserveCurrentQuery: true,
      useFacetParam: searchUsesConvermaxFacetParam(currentSearch) || convermaxPreservedQueryParams(currentSearch).length > 0,
    });
    var nextPath = String(window.location.pathname || '/')
      + (query ? '?' + query : '')
      + String(window.location.hash || '');
    var currentPath = String(window.location.pathname || '/')
      + String(window.location.search || '')
      + String(window.location.hash || '');
    if (nextPath === currentPath) return false;

    window.history?.pushState?.(window.history.state, document.title, nextPath);
    dispatchConvermaxPopState();
    syncFilterDialogButtonLabels(document);
    scheduleProductTypeV3FilterRefreshes();
    return true;
  }

  function hasVisibleActiveFilterChips() {
    return Array.from(document.querySelectorAll('.cmTemplate_chip')).some(function (chip) {
      return !chip.hidden;
    });
  }

  function clearUrlFiltersAfterNativeActiveFilterClearAll() {
    if (!lastActiveFilterChipParts.length) return false;
    if (hasVisibleActiveFilterChips()) return false;

    var removed = clearConvermaxUrlFilterParts(lastActiveFilterChipParts);
    lastActiveFilterChipParts = [];
    return removed;
  }

  function activeFilterClearAllParts(button) {
    var root = button?.closest?.('.parity-cm-active-filters')
      || button?.closest?.('.cm_FilterChips, .cm_filterChips');
    var parts = activeFilterChipPartsFromRoot(root);

    return parts.length ? parts : lastActiveFilterChipParts.slice();
  }

  function scheduleActiveFilterClearAllUrlReconciliation(parts) {
    var filters = (parts || []).filter(Boolean);
    if (!filters.length) return;

    [0, 80, 250, 700, 1400].forEach(function (delay) {
      window.setTimeout(function () {
        clearConvermaxUrlFilterParts(filters);
        if (!hasVisibleActiveFilterChips()) removeAllActiveFilterHosts();
      }, delay);
    });
  }

  function clearVisibleActiveFilterUrl(button) {
    var parts = activeFilterClearAllParts(button);
    if (!parts.length) return clearAllConvermaxFilterUrl();

    lastActiveFilterChipParts = parts;
    var removed = clearConvermaxUrlFilterParts(parts);
    scheduleActiveFilterClearAllUrlReconciliation(parts);
    return removed || true;
  }

  function activeFilterClearAllButtonFromEvent(event) {
    var button = event.target?.closest?.('[data-parity-cm-clear-all], .cm_filter-chips_button, [data-cm-role="start-over"]');
    if (!button) return;

    var chips = button.closest?.('.cm_FilterChips, .cm_filterChips');
    var activeHost = button.closest?.('.parity-cm-active-filters');
    if (!chips && !activeHost) return null;
    if (button.closest?.('#cm-garage, #cm-mobile-garage, .cm_garageDropdown')) return null;

    return button;
  }

  function isPrimaryClickLikeEvent(event) {
    if (event.type !== 'click' && event.type !== 'pointerdown') return true;
    return !event.button || event.button === 0;
  }

  function handleActiveFilterClearAllClick(event) {
    if (!isPrimaryClickLikeEvent(event)) return;

    var button = activeFilterClearAllButtonFromEvent(event);
    if (!button) return;
    var handled = button.dataset.parityCmClearAllClickHandled === 'true';
    if (handled) {
      removeAllActiveFilterHosts();
    } else if (!clearVisibleActiveFilterUrl(button)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function handleActiveFilterClearAllPointerDown(event) {
    if (!isPrimaryClickLikeEvent(event)) return;

    var button = activeFilterClearAllButtonFromEvent(event);
    if (!button) return;
    if (!clearVisibleActiveFilterUrl(button)) return;

    button.dataset.parityCmClearAllClickHandled = 'true';
    window.setTimeout(function () {
      if (button.isConnected && button.dataset.parityCmClearAllClickHandled === 'true') {
        removeAllActiveFilterHosts();
      }
    }, 250);
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function handleActiveFilterChipClick(event) {
    if (removingGroupedActiveFilterChips) return;
    if (!isPrimaryClickLikeEvent(event)) return;

    var chip = activeFilterChipFromEvent(event);
    if (!chip) return;

    if (event.target?.closest?.('.facetentryval')) {
      if (!removeActiveProductTypeV3ChipGroup(chip) && !removeConvermaxFilterForActiveChip(chip)) return;

      chip.dataset.parityCmActiveFilterClickHandled = 'true';
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (removeActiveProductTypeV3ChipGroup(chip) || removeConvermaxFilterForActiveChip(chip)) {
      chip.dataset.parityCmActiveFilterClickHandled = 'true';
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var remove = chip.querySelector('.facetentryval');
    if (!remove) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    chip.dataset.parityCmActiveFilterClickHandled = 'true';
    remove.click();
  }

  function handleActiveFilterChipPointerDown(event) {
    if (removingGroupedActiveFilterChips) return;
    if (!isPrimaryClickLikeEvent(event)) return;

    var chip = activeFilterChipFromEvent(event);
    if (!chip) return;

    chip.dataset.parityCmActiveFilterClickHandled = '';
    window.setTimeout(function () {
      if (chip.dataset.parityCmActiveFilterClickHandled === 'true') return;
      handleActiveFilterChipClick({
        target: event.target,
        type: 'click',
        preventDefault: function () {},
        stopImmediatePropagation: function () {},
      });
    }, 80);
  }

  function handleActiveFilterChipKeydown(event) {
    if (removingGroupedActiveFilterChips) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var chip = activeFilterChipFromEvent(event);
    if (!chip || event.target?.closest?.('.facetentryval')) return;

    if (removeActiveProductTypeV3ChipGroup(chip) || removeConvermaxFilterForActiveChip(chip)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var remove = chip.querySelector('.facetentryval');
    if (!remove) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    remove.click();
  }

  function setupFilterChrome() {
    normalizeFilterChrome(document);

    if (filterChromeScheduled) return;
    filterChromeScheduled = true;

    window.addEventListener('click', handleActiveFilterClearAllClick, true);
    window.addEventListener('click', handleActiveFilterChipClick, true);
    window.addEventListener('pointerdown', handleActiveFilterClearAllPointerDown, true);
    window.addEventListener('pointerdown', handleActiveFilterChipPointerDown, true);
    window.addEventListener('keydown', handleActiveFilterChipKeydown, true);
    document.addEventListener('click', handleProductTypeV3OptionActivation, true);
    document.addEventListener('click', handleFilterFacetToggle, true);
    document.addEventListener('click', handleFilterDialogOpen, true);
    document.addEventListener('click', handleActiveFilterClearAllClick, true);
    document.addEventListener('click', handleActiveFilterChipClick, true);
    document.addEventListener('pointerdown', handleActiveFilterClearAllPointerDown, true);
    document.addEventListener('pointerdown', handleActiveFilterChipPointerDown, true);
    document.addEventListener('keydown', handleProductTypeV3OptionActivation, true);
    document.addEventListener('keydown', handleFilterFacetToggle, true);
    document.addEventListener('keydown', handleActiveFilterChipKeydown, true);
  }

  function isVehicleDialogWidget(node) {
    return Boolean(node?.closest?.('.cm_vehicle-widget__dialog, #cm_VehicleWidgetDialog, .VehicleWidgetDialog, .vehicle-dialog'));
  }

  function getVehicleWidget(node) {
    return node?.closest?.('.cm_vehicle-widget') || null;
  }

  function isVerifyFitmentWidget(widget) {
    return Boolean(widget?.classList?.contains('cm_vehicle-widget__verify-fitment'));
  }

  function vehicleFilterQuery(vehicle) {
    var parts = ['Year', 'Make', 'Model', 'Submodel']
      .filter(function (field) { return vehicle[field]; })
      .map(function (field) { return field + '/' + encodeVehicleSegment(vehicle[field]); });

    if (parts.length) return parts.join('/');

    if (window.Convermax?.getVehicleSearchParams) {
      var params = window.Convermax.getVehicleSearchParams();
      if (params) return String(params).replace(/^\?/, '');
    }

    return '';
  }

  function appendConvermaxQuery(url, query) {
    if (!query) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
  }

  function currentCollectionPath() {
    var path = window.location?.pathname || '';
    var match = path.match(/^(.*\/collections\/[^/]+)\/?$/);
    if (!match) return '';

    var collectionPath = match[1].replace(/\/+$/, '');
    if (/\/collections\/(?:types|vendors)$/i.test(collectionPath)) return '';

    return collectionPath;
  }

  function hasCategoryPageContext() {
    return Boolean(document.querySelector('[data-parity-category-tree], [data-parity-moto-product-header]'));
  }

  function currentCategoryCollectionUrl() {
    var collectionPath = currentCollectionPath();
    if (!collectionPath) return '';
    if (hasCategoryPageContext()) return collectionPath;
    if (/\/collections\/motorcycle(?:-|$)/i.test(collectionPath)) return collectionPath;

    return '';
  }

  function vehicleSearchUrl(vehicle) {
    var query = vehicleFilterQuery(vehicle);
    if (query) return appendConvermaxQuery('/pages/search', query);

    return '/pages/search';
  }

  function vehicleShopPartsUrl(vehicle) {
    return appendConvermaxQuery(currentCategoryCollectionUrl() || garageShopPartsUrl, vehicleFilterQuery(vehicle));
  }

  function vehicleLabel(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return String(vehicle?.[field] || '').trim(); })
      .filter(Boolean)
      .join(' ');
  }

  function vehicleFromWidget(widget) {
    if (!widget) return null;

    var vehicle = {};

    widget.querySelectorAll('select[aria-label]').forEach(function (select) {
      var field = select.getAttribute('aria-label');
      if (vehicleFields.indexOf(field) === -1 || !select.value) return;
      vehicle[field] = select.value;
    });

    if (!vehicle.Year || !vehicle.Make || !vehicle.Model) return null;
    if (!Object.prototype.hasOwnProperty.call(vehicle, 'Submodel')) vehicle.Submodel = '';

    return vehicle;
  }

  function selectedVariantId() {
    var selectedVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (selectedVariant?.value) return selectedVariant.value;

    var product = window.meta?.product || window.ShopifyAnalytics?.meta?.product;
    return product?.variants?.[0]?.id || null;
  }

  function selectedProductId() {
    var product = window.meta?.product || window.ShopifyAnalytics?.meta?.product;
    if (product?.id) return product.id;

    var productForm = document.querySelector('form[id^="product_form_"]');
    var match = productForm?.id?.match(/^product_form_(\d+)/);
    return match?.[1] || null;
  }

  function refreshVerifyFitmentWidget() {
    if (!document.querySelector('.cm_vehicle-widget__verify-fitment')) return;
    if (!window.Convermax?.updateVerifyFitmentWidget) return;

    var productId = selectedProductId();
    var variantId = selectedVariantId();
    if (!productId) return;

    window.setTimeout(function () {
      window.Convermax.updateVerifyFitmentWidget(productId, variantId);
    }, 50);
    window.setTimeout(function () {
      window.Convermax.updateVerifyFitmentWidget(productId, selectedVariantId() || variantId);
    }, 650);
  }

  function dispatchVehicleSelected(vehicle, searchUrl) {
    var detail = { vehicle: vehicle, searchUrl: searchUrl };
    document.dispatchEvent(new CustomEvent('garage:vehicle-updated', { bubbles: true, detail: detail }));
    window.dispatchEvent(new CustomEvent('parity:garage-vehicle-selected', { detail: detail }));
  }

  function compactVehicle(vehicle) {
    var compact = {
      Year: vehicle.Year,
      Make: vehicle.Make,
      Model: vehicle.Model,
      Submodel: vehicle.Submodel || '',
    };

    return compact;
  }

  function vehicleKey(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return String(vehicle?.[field] || ''); })
      .join('\u0000');
  }

  function looseVehicleKey(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return clean(vehicle?.[field]); })
      .join('\u0000');
  }

  function vehicleLabelKey(vehicle) {
    return clean(vehicleLabel(vehicle));
  }

  function vehicleDedupeKeys(vehicle) {
    return [
      'strict:' + vehicleKey(vehicle),
      'loose:' + looseVehicleKey(vehicle),
      'label:' + vehicleLabelKey(vehicle),
    ].filter(function (key) { return !/:\s*$/.test(key); });
  }

  function vehicleMatchIndex(list, vehicle) {
    var keys = new Set(vehicleDedupeKeys(vehicle));

    for (var index = 0; index < list.length; index += 1) {
      var existingKeys = vehicleDedupeKeys(list[index]);
      if (existingKeys.some(function (key) { return keys.has(key); })) return index;
    }

    return -1;
  }

  function selectedVehicleList(vehicle) {
    var selected = compactVehicle(vehicle);
    var list = [];

    function pushUnique(item, replaceExisting) {
      var compact = compactVehicle(item);
      var matchIndex = vehicleMatchIndex(list, compact);

      if (matchIndex >= 0) {
        if (replaceExisting) list[matchIndex] = compact;
        return;
      }

      list.push(compact);
    }

    try {
      (window.Convermax?.getVehicleList?.() || []).forEach(function (item) {
        pushUnique(item, false);
      });
    } catch (_error) {
      // Convermax can be mid-render while the dialog is closing; keep the selected vehicle below.
    }

    pushUnique(selected, true);
    return list;
  }

  function vehicleListsEqual(left, right) {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false;

    return left.every(function (vehicle, index) {
      return vehicleKey(compactVehicle(vehicle)) === vehicleKey(compactVehicle(right[index]));
    });
  }

  function recentGarageVehicle() {
    if (!window.Convermax?.getVehicleList) return null;

    try {
      var list = window.Convermax.getVehicleList() || [];
      for (var index = list.length - 1; index >= 0; index -= 1) {
        var vehicle = list[index];
        if (vehicle?.Year && vehicle?.Make && vehicle?.Model) return compactVehicle(vehicle);
      }
    } catch (_error) {
      return null;
    }

    return null;
  }

  function garageVehicleList() {
    if (!window.Convermax?.getVehicleList) return [];

    try {
      var seen = new Set();
      var list = [];

      (window.Convermax.getVehicleList() || []).forEach(function (item) {
        if (!item?.Year || !item?.Make || !item?.Model) return;

        var vehicle = compactVehicle(item);
        var keys = vehicleDedupeKeys(vehicle);
        if (keys.some(function (key) { return seen.has(key); })) return;

        keys.forEach(function (key) { seen.add(key); });
        list.push(vehicle);
      });

      return list;
    } catch (_error) {
      return [];
    }
  }

  function selectedGarageVehicle() {
    if (!window.Convermax?.getVehicle) return null;

    try {
      var vehicle = window.Convermax.getVehicle() || {};
      if (vehicle?.Year && vehicle?.Make && vehicle?.Model) return compactVehicle(vehicle);
    } catch (_error) {
      return null;
    }

    return null;
  }

  function garageVehicleFromNode(node) {
    if (!node || !window.Convermax?.getVehicleList) return null;

    var nodeLabel = clean(node.textContent || '');
    if (!nodeLabel) return null;

    try {
      var list = window.Convermax.getVehicleList() || [];
      for (var index = 0; index < list.length; index += 1) {
        var vehicle = compactVehicle(list[index]);
        var label = clean(vehicleLabel(vehicle));
        if (label && (nodeLabel === label || nodeLabel.indexOf(label) !== -1 || label.indexOf(nodeLabel) !== -1)) {
          return vehicle;
        }
      }
    } catch (_error) {
      return null;
    }

    return null;
  }

  function garageSavedVehicleTarget(target) {
    if (!target?.closest) return null;
    if (target.closest('.remove-model, [data-cm-role="remove-vehicle"]')) return null;

    var dropdown = target.closest('.cm_garageDropdown');
    if (!dropdown) return null;

    var directTarget = target.closest('[data-cm-role="select-vehicle"], .select-model');
    if (directTarget && dropdown.contains(directTarget)) return directTarget;

    var rowTarget = target.closest('.garage-item, .cmRepeater_item, .cmTemplate_item');
    if (!rowTarget || !dropdown.contains(rowTarget)) return null;

    return rowTarget.querySelector('[data-cm-role="select-vehicle"], .select-model') || rowTarget;
  }

  function dedupeGarageVehicleList(vehicle) {
    if (!window.Convermax?.setVehicleList || !window.Convermax?.getVehicleList) return;

    var current = window.Convermax.getVehicleList();
    var deduped = selectedVehicleList(vehicle);
    if (vehicleListsEqual(current, deduped)) return;

    window.Convermax.setVehicleList(deduped);
    refreshVerifyFitmentWidget();
  }

  function saveVehicle(vehicle) {
    if (!vehicle || !window.Convermax) return null;

    try {
      window.Convermax.setVehicle?.(vehicle);
    } catch (error) {
      if (!Object.prototype.hasOwnProperty.call(vehicle, 'Submodel')) throw error;
      var minimalVehicle = {
        Year: vehicle.Year,
        Make: vehicle.Make,
        Model: vehicle.Model,
      };
      window.Convermax.setVehicle?.(minimalVehicle);
    }

    var searchUrl = vehicleSearchUrl(vehicle);
    dedupeGarageVehicleList(vehicle);
    refreshVerifyFitmentWidget();
    dispatchVehicleSelected(vehicle, searchUrl);
    pendingGarageDialogSelection = null;
    window.setTimeout(function () {
      dedupeGarageVehicleList(vehicle);
    }, 1200);
    window.setTimeout(function () {
      renderRecentGarageVehicleActions(document);
    }, 0);
    return searchUrl;
  }

  function isGarageWidget(widget) {
    return Boolean(widget?.closest?.('#cm-garage, #cm-mobile-garage, .cm_garageDropdown'));
  }

  function inlineVehicleWidgets(root) {
    return Array.from((root || document).querySelectorAll?.('.cm_vehicle-widget') || [])
      .filter(function (widget) {
        if (isVehicleDialogWidget(widget) || isVerifyFitmentWidget(widget) || isGarageWidget(widget)) return false;
        return Boolean(widget.querySelector('.cm_vehicle-widget_title'));
      });
  }

  function hideNativeRecentVehicle(widget, action) {
    widget.querySelectorAll('[data-parity-native-recent-vehicle-hidden="true"]').forEach(function (node) {
      node.hidden = false;
      node.removeAttribute('data-parity-native-recent-vehicle-hidden');
    });

    Array.from(widget.querySelectorAll('*')).forEach(function (node) {
      if (action && (node === action || node.contains(action) || action.contains(node))) return;
      if (node.matches('select, option')) return;

      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/\bRecent Vehicle\b/i.test(text)) return;

      var childHasRecent = Array.from(node.children).some(function (child) {
        return /\bRecent Vehicle\b/i.test((child.textContent || '').replace(/\s+/g, ' ').trim());
      });
      if (childHasRecent) return;

      var container = node;
      while (container.parentElement && container.parentElement !== widget) {
        var parent = container.parentElement;
        if (parent.contains(action) || parent.querySelector('select, .cm_vehicle-widget_title')) break;
        if ((parent.textContent || '').replace(/\s+/g, ' ').trim().length > 180) break;
        container = parent;
      }

      container.hidden = true;
      container.dataset.parityNativeRecentVehicleHidden = 'true';
    });
  }

  function ensureInlineVehicleHeading(widget, title) {
    var existing = Array.from(widget.querySelectorAll('.parity-cm-vehicle-widget__heading')).find(function (node) {
      return node.contains(title);
    });
    if (existing) return existing;

    var parent = title?.parentElement || widget;
    var body = Array.from(parent.children).find(function (child) {
      return child !== title && (child.matches?.('.cm_vehicle-widget_body') || child.querySelector?.('select, .cm_vehicle-widget_button__go'));
    });

    if (!body) {
      parent.classList.add('parity-cm-vehicle-widget__heading');
      return parent;
    }

    var heading = document.createElement('div');
    heading.className = 'parity-cm-vehicle-widget__heading';
    parent.insertBefore(heading, title);

    while (heading.nextSibling && heading.nextSibling !== body) {
      heading.appendChild(heading.nextSibling);
    }

    return heading;
  }

  function ensureInlineGarageActions(header) {
    var actions = header.querySelector(':scope > .parity-inline-garage-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'parity-inline-garage-actions';
      header.appendChild(actions);
    }
    return actions;
  }

  function ensureSavedGarageVehicleAction(actions) {
    var action = actions.querySelector('[data-parity-saved-garage-vehicle="true"]');
    if (!action) {
      action = document.createElement('div');
      action.className = 'parity-saved-garage-vehicle';
      action.dataset.paritySavedGarageVehicle = 'true';
      action.innerHTML = '<span class="parity-saved-garage-vehicle__label">Garage</span><button class="parity-saved-garage-vehicle__button" type="button" data-parity-saved-garage-vehicle-open>Select a Saved Vehicle</button>';
      actions.appendChild(action);
    }
    return action;
  }

  function removeInlineSavedGaragePopovers(root) {
    (root || document).querySelectorAll?.('.parity-saved-garage-popover').forEach(function (popover) {
      popover.remove();
    });
    (root || document).querySelectorAll?.('[data-parity-saved-garage-vehicle-open][aria-expanded="true"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function renderInlineSavedGaragePopover(action) {
    if (!action) return null;

    var existing = action.querySelector('.parity-saved-garage-popover');
    if (existing) {
      existing.remove();
      action.querySelector('[data-parity-saved-garage-vehicle-open]')?.setAttribute('aria-expanded', 'false');
      return null;
    }

    removeInlineSavedGaragePopovers(document);

    var vehicles = garageVehicleList();
    var popover = document.createElement('div');
    popover.className = 'parity-saved-garage-popover';
    popover.dataset.paritySavedGaragePopoverOpen = 'true';
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-label', 'Select a saved vehicle');

    popover.innerHTML = '<div class="parity-saved-garage-popover__title">Select a Vehicle</div><div class="parity-saved-garage-popover__group-title">Saved Vehicles</div><div class="parity-saved-garage-popover__list"></div>';

    var list = popover.querySelector('.parity-saved-garage-popover__list');
    if (vehicles.length) {
      vehicles.forEach(function (vehicle, index) {
        var button = document.createElement('button');
        button.className = 'parity-saved-garage-popover__vehicle';
        button.type = 'button';
        button.dataset.paritySavedGarageVehicleIndex = String(index);
        button.textContent = vehicleLabel(vehicle);
        list.appendChild(button);
      });
    } else {
      var empty = document.createElement('div');
      empty.className = 'parity-saved-garage-popover__empty';
      empty.textContent = 'No saved vehicles';
      list.appendChild(empty);
    }

    action.appendChild(popover);
    action.querySelector('[data-parity-saved-garage-vehicle-open]')?.setAttribute('aria-expanded', 'true');
    return popover;
  }

  function ensureRecentGarageVehicleAction(actions) {
    var action = actions.querySelector('[data-parity-recent-garage-vehicle="true"]');
    if (!action) {
      action = document.createElement('div');
      action.className = 'parity-recent-garage-vehicle';
      action.dataset.parityRecentGarageVehicle = 'true';
      action.innerHTML = '<span class="parity-recent-garage-vehicle__label">Recent Vehicle</span><button class="parity-recent-garage-vehicle__button" type="button" data-parity-recent-garage-vehicle-select></button>';
      actions.appendChild(action);
    }
    return action;
  }

  function renderRecentGarageVehicleActions(root) {
    var vehicle = recentGarageVehicle();
    var selectedVehicle = selectedGarageVehicle();

    inlineVehicleWidgets(root).forEach(function (widget) {
      var recentAction = widget.querySelector('[data-parity-recent-garage-vehicle="true"]');
      var savedAction = widget.querySelector('[data-parity-saved-garage-vehicle="true"]');

      if (!vehicle) {
        widget.querySelectorAll('[data-parity-native-recent-vehicle-hidden="true"]').forEach(function (node) {
          node.hidden = false;
          node.removeAttribute('data-parity-native-recent-vehicle-hidden');
        });
        recentAction?.remove();
        savedAction?.remove();
        removeInlineSavedGaragePopovers(widget);
        widget.classList.remove('parity-cm-vehicle-widget--recent');
        widget.classList.remove('parity-cm-vehicle-widget--inline-actions');
        return;
      }

      var title = widget.querySelector('.cm_vehicle-widget_title');
      var header = ensureInlineVehicleHeading(widget, title);
      var actions = ensureInlineGarageActions(header);
      var label = vehicleLabel(vehicle);

      ensureSavedGarageVehicleAction(actions);

      if (selectedVehicle) {
        recentAction?.remove();
      } else {
        recentAction = ensureRecentGarageVehicleAction(actions);
        recentAction.querySelector('.parity-recent-garage-vehicle__button').textContent = label;
        recentAction.querySelector('.parity-recent-garage-vehicle__button').setAttribute('aria-label', 'Select recent vehicle ' + label);
      }

      widget.classList.add('parity-cm-vehicle-widget--recent');
      widget.classList.add('parity-cm-vehicle-widget--inline-actions');
      header.classList.add('parity-cm-vehicle-widget__heading');
      hideNativeRecentVehicle(widget, actions);
    });
  }

  function closeVehicleDialog() {
    var dialog = document.querySelector('#cm_VehicleWidgetDialog, .VehicleWidgetDialog.vehicle-dialog');
    var close = dialog?.querySelector?.('.close');

    if (close) {
      close.click();
      return;
    }

    if (dialog) dialog.remove();
    document.documentElement.classList.remove('cm_no-scroll');
    document.body.classList.remove('cm_no-scroll');
  }

  function navigateToShopPartsCollection(vehicle) {
    var url = vehicleShopPartsUrl(vehicle);
    if (!saveVehicle(vehicle)) return;
    window.location.href = url;
  }

  function triggerGarageAddVehicle() {
    var garage = document.querySelector('#cm-mobile-garage') || garageDropdownRoot();

    if (garage) setGarageDropdownOpen(garage, true);

    var addVehicle = garage?.querySelector?.('.add-vehicle, .cm_addButton, [data-cm-role="add-vehicle"]')
      || document.querySelector('#cm-mobile-garage .add-vehicle, #cm-mobile-garage .cm_addButton, #cm-garage .add-vehicle, #cm-garage .cm_addButton, .cm_garage .add-vehicle, .cm_garage .cm_addButton');

    if (addVehicle) {
      addVehicle.click();
      return true;
    }

    return Boolean(garage);
  }

  function shopByVehicleFromHeader() {
    var selectedVehicle = selectedGarageVehicle();

    if (selectedVehicle) {
      navigateToShopPartsCollection(selectedVehicle);
      return true;
    }

    return triggerGarageAddVehicle();
  }

  function applyGarageVehicleInPlace(vehicle) {
    if (!saveVehicle(vehicle)) return false;
    renderRecentGarageVehicleActions(document);
    scheduleSortAll();
    return true;
  }

  function garageDropdownRoot() {
    return document.querySelector('#cm-garage') || document.querySelector('#cm-mobile-garage') || document.querySelector('.cm_garage');
  }

  function syncGarageDropdownTriggerState(garage, open) {
    garage?.querySelectorAll?.('.garage-button').forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) button.classList.remove('active', 'is-active', 'open');
    });
  }

  function setGarageDropdownOpen(garage, open) {
    var dropdown = garage?.querySelector?.('.cm_garageDropdown');
    if (!dropdown) return false;

    syncGarageDropdownTriggerState(garage, open);

    if (open) {
      dropdown.hidden = false;
      dropdown.removeAttribute('aria-hidden');
      dropdown.classList.add('parity-garage-dropdown-open');
      garage.classList.add('parity-garage-dropdown-owner-open');
      if (window.getComputedStyle?.(dropdown).display === 'none') {
        dropdown.style.display = 'block';
      }
      return true;
    }

    dropdown.classList.remove('parity-garage-dropdown-open');
    garage.classList.remove('parity-garage-dropdown-owner-open');
    dropdown.style.display = 'none';
    return true;
  }

  function closeGarageDropdown(node) {
    var garage = node?.closest?.('#cm-garage, #cm-mobile-garage, .cm_garage') || garageDropdownRoot();
    setGarageDropdownOpen(garage, false);
  }

  function ensureContinueShoppingButton(widget, vehicle) {
    var go = widget?.querySelector?.('.cm_vehicle-widget_button__go');
    if (!go) return null;

    var container = go.parentElement || widget.querySelector('.cm_vehicle-widget_body') || widget;
    var button = container.querySelector('.parity-garage-continue');

    if (!button) {
      button = document.createElement('div');
      button.className = 'parity-garage-continue cm_vehicle-widget_button cm_button button-secondary';
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      go.insertAdjacentElement('afterend', button);
    }

    button.textContent = 'Continue Shopping';
    button.dataset.parityGarageContinue = 'true';
    button.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      saveVehicle(vehicleFromWidget(widget) || vehicle);
      closeVehicleDialog();
    };
    button.onkeydown = function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      button.click();
    };

    return button;
  }

  function hideDialogClearButton(widget) {
    if (!isVehicleDialogWidget(widget)) return;

    widget.querySelectorAll('.cm_vehicle-widget_button__clear').forEach(function (button) {
      button.hidden = true;
      button.style.display = 'none';
      button.dataset.parityGarageClearHidden = 'true';
    });
  }

  function labelGarageActionButtons(root) {
    (root || document).querySelectorAll?.('.cm_vehicle-widget_button__go').forEach(function (button) {
      var widget = getVehicleWidget(button);
      if (!widget || isVerifyFitmentWidget(widget)) return;
      button.textContent = 'Shop Parts';
      button.dataset.parityGarageShopAll = 'true';
      hideDialogClearButton(widget);
    });
  }

  function renderGarageNavigationActions(widget, vehicle) {
    if (!widget || !vehicle) return;

    pendingGarageDialogSelection = {
      vehicle: compactVehicle(vehicle),
      widget: widget,
    };

    var go = widget.querySelector('.cm_vehicle-widget_button__go');
    if (go) {
      go.textContent = 'Shop Parts';
      go.dataset.parityGarageShopAll = 'true';
      go.removeAttribute('disabled');
      go.setAttribute('aria-disabled', 'false');
    }

    hideDialogClearButton(widget);
    ensureContinueShoppingButton(widget, vehicle);
  }

  function handleGarageDialogDismissClick(event) {
    if (!pendingGarageDialogSelection?.vehicle) return;

    var target = event.target;
    var dialog = document.querySelector('#cm_VehicleWidgetDialog, .VehicleWidgetDialog.vehicle-dialog');
    if (!dialog) {
      pendingGarageDialogSelection = null;
      return;
    }

    if (target?.closest?.('.cm_vehicle-widget__dialog')) return;
    if (!dialog.contains(target) && !target?.closest?.('.VehicleWidgetDialog, .vehicle-dialog')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    saveVehicle(pendingGarageDialogSelection.vehicle);
    closeVehicleDialog();
  }

  function isFinalVehicleSelect(select, widget) {
    if (!select || !widget) return false;
    if (select.getAttribute('aria-label') !== 'Model' && select.getAttribute('aria-label') !== 'Submodel') return false;

    return Array.from(widget.querySelectorAll('select[aria-label]')).every(function (item) {
      var label = item.getAttribute('aria-label');
      if (vehicleFields.indexOf(label) === -1 || item.disabled) return true;
      if (label === 'Submodel' && item.options.length <= 1) return true;
      return Boolean(item.value);
    });
  }

  function handleGarageDialogChange(event) {
    var target = event.target;
    if (!target?.matches?.('select[aria-label]')) return;

    var widget = getVehicleWidget(target);
    if (!isVehicleDialogWidget(target) || !isFinalVehicleSelect(target, widget)) return;

    var vehicle = vehicleFromWidget(widget);
    if (!vehicle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    renderGarageNavigationActions(widget, vehicle);
  }

  function handleGarageActionClick(event) {
    var inlineSavedVehicleTarget = event.target?.closest?.('[data-parity-saved-garage-vehicle-index]');
    if (inlineSavedVehicleTarget) {
      var vehicleIndex = Number(inlineSavedVehicleTarget.getAttribute('data-parity-saved-garage-vehicle-index'));
      var inlineVehicle = garageVehicleList()[vehicleIndex];
      if (!inlineVehicle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToShopPartsCollection(inlineVehicle);
      return;
    }

    var savedOpenTarget = event.target?.closest?.('[data-parity-saved-garage-vehicle-open]');
    if (savedOpenTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
      renderInlineSavedGaragePopover(savedOpenTarget.closest('[data-parity-saved-garage-vehicle="true"]'));
      return;
    }

    var savedSelectTarget = garageSavedVehicleTarget(event.target);
    if (savedSelectTarget) {
      var savedVehicle = garageVehicleFromNode(savedSelectTarget);
      if (savedVehicle) {
        event.preventDefault();
        event.stopImmediatePropagation();
        navigateToShopPartsCollection(savedVehicle);
        return;
      }
    }

    var recentTarget = event.target?.closest?.('[data-parity-recent-garage-vehicle-select]');
    if (recentTarget) {
      var recentVehicle = recentGarageVehicle();
      if (!recentVehicle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToShopPartsCollection(recentVehicle);
      return;
    }

    var target = event.target?.closest?.('.cm_vehicle-widget_button__go, .parity-garage-continue');
    if (!target) return;

    var widget = getVehicleWidget(target);
    if (!widget || isVerifyFitmentWidget(widget)) return;

    var pendingVehicle = isVehicleDialogWidget(widget) ? pendingGarageDialogSelection?.vehicle : null;
    var vehicle = vehicleFromWidget(widget) || pendingVehicle || window.Convermax?.getVehicle?.();
    if (!vehicle?.Year || !vehicle?.Make || !vehicle?.Model) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (target.matches('.parity-garage-continue')) {
      saveVehicle(vehicle);
      closeVehicleDialog();
      return;
    }

    navigateToShopPartsCollection(vehicle);
  }

  function setupGarageNavigation() {
    labelGarageActionButtons(document);
    renderRecentGarageVehicleActions(document);

    if (garageNavigationScheduled) return;
    garageNavigationScheduled = true;

    document.addEventListener('change', handleGarageDialogChange, true);
    document.addEventListener('click', handleGarageActionClick, true);
    document.addEventListener('click', handleGarageDialogDismissClick, true);
    document.addEventListener('click', function (event) {
      if (event.target?.closest?.('.parity-saved-garage-vehicle')) return;
      removeInlineSavedGaragePopovers(document);
    }, true);
  }

  function scheduleSortAll() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sortAll(document);
      labelGarageActionButtons(document);
      renderRecentGarageVehicleActions(document);
      syncCategoryFacets();
      normalizeFilterChrome(document);
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleSortAll).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-expanded', 'aria-label', 'class', 'disabled', 'id', 'name', 'style'],
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  window.ParityConvermaxMakeOrder = {
    dedupeGarageVehicleList: dedupeGarageVehicleList,
    normalizeFilterChrome: normalizeFilterChrome,
    normalizeFilterFacets: normalizeFilterFacets,
    renderRecentGarageVehicleActions: renderRecentGarageVehicleActions,
    shopByVehicleFromHeader: shopByVehicleFromHeader,
    syncFilterCues: syncFilterCues,
    sortAll: sortAll,
    sortSelect: sortSelect,
  };

  normalizeConvermaxLocationQuery();
  normalizeProductTypeV3LocationQuery();
  sortAll(document);
  setupGarageNavigation();
  syncCategoryFacets();
  setupFilterChrome();
  document.addEventListener('DOMContentLoaded', scheduleSortAll);
  window.addEventListener('load', scheduleSortAll);
  window.setTimeout(scheduleSortAll, 250);
  window.setTimeout(scheduleSortAll, 1000);
  window.setTimeout(scheduleSortAll, 2500);
}());
